/**
 * InsulaCharter - Localización Española
 * Adaptado de AlguerHouse para alquiler de barcos
 */

const es = {
  // ============================================
  // MARKUP INCLUSIVE (solicitud/aprobación)
  // ============================================
  markupInclusive: {
    title: 'Precios inclusive',
    subtitle: 'Solicita que el margen de la plataforma se incluya en el precio mostrado',
    rental: 'Alquiler',
    excursion: 'Excursiones',
    statusActive: 'Activo',
    statusPending: 'Pendiente de aprobación',
    statusInactive: 'No activo',
    request: 'Solicitar',
    requested: 'Solicitud enviada',
    requestError: 'Error al enviar la solicitud',
    approve: 'Aprobar',
    reject: 'Rechazar',
    approved: 'Solicitud aprobada',
    rejected: 'Solicitud rechazada',
    actionError: 'Error en la operación',
    adminTitle: 'Margen inclusive',
    adminHint: 'Aprueba o rechaza las solicitudes de precio inclusive por rama.',
    vendorHint: 'Hasta la aprobación el precio permanece aditivo (margen aparte).',
  },
  // ============================================
  // METADATA & SEO
  // ============================================
  metadata: {
    siteTitle: 'InsulaCharter - Alquiler de Barcos en Cerdeña',
    siteDescription: 'Encuentra el barco perfecto para tu aventura en las aguas cristalinas de la Costa Esmeralda y las calas de Cerdeña.',
    loginTitle: 'Iniciar sesión - InsulaCharter',
    loginDescription: 'Inicia sesión en tu cuenta de InsulaCharter',
    registerTitle: 'Regístrate - InsulaCharter',
    registerDescription: 'Crea tu cuenta de InsulaCharter',
  },

  // ============================================
  // COMMON / SHARED
  // ============================================
  common: {
    all: 'Todos',
    loading: 'Cargando...',
    error: 'Error',
    errorPrefix: 'Error: ',
    serverError: 'Error del servidor',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    success: 'Operación completada',
    save: 'Guardar',
    saving: 'Guardando...',
    create: 'Crear',
    edit: 'Editar',
    delete: 'Eliminar',
    search: 'Buscar',
    searchNow: 'BUSCAR AHORA',
    back: 'Atrás',
    next: 'Siguiente',
    close: 'Cerrar',
    yes: 'Sí',
    no: 'No',
    free: 'Gratis',
    included: 'Incluido',
    day: 'día',
    days: 'días',
    guest: 'pasajero',
    guests: 'pasajeros',
    passengers: 'pasajeros',
    boat: 'Barco',
    meters: 'metros',
    person: 'Persona',
    persons: 'Personas',
    total: 'Total',
    price: 'Precio',
    perDay: '/día',
    today: 'Hoy',
    uploading: 'Subiendo...',
    sending: 'Enviando...',
    hour: 'hora',
    hours: 'horas',
    loginRequired: 'Inicio de sesión requerido',
    from: 'Desde',
  },

  // ============================================
  // NAVBAR
  // ============================================
  navbar: {
    logo: 'InsulaCharter',
    maintenanceMode: 'MODO MANTENIMIENTO - El sitio solo es visible para ti',
    maintenanceShort: 'MANTENIMIENTO',
    exitMaintenance: 'Salir',
    accountActive: 'Cuenta Activa',
    roleHost: 'Armador',
    roleGuest: 'Invitado',
    adminPanel: 'Panel',
    adminSettings: 'Configuración',
    myTrips: 'Mis Alquileres',
    myRequests: 'Mis solicitudes',
    logout: 'Cerrar sesión',
    login: 'Iniciar sesión',
  },

  // ============================================
  // FOOTER
  // ============================================
  footer: {
    description: 'Experiencias náuticas exclusivas en Cerdeña, creadas con pasión para garantizarte el máximo confort en el mar.',
    quickLinks: 'Enlaces Rápidos',
    exploreBoats: 'Explora la Flota',
    reservedArea: 'Área Reservada',
    contacts: 'Contacto',
    location: 'Cerdeña, Italia',
    copyright: '© 2026 InsulaCharter.',
  },

  // ============================================
  // HOMEPAGE
  // ============================================
  home: {
    tagline: 'Cerdeña • Costa Esmeralda',
    welcomeTitle: 'El Mar Te Espera',
    welcomeSubtitle: 'Encuentra el barco perfecto para tu aventura en las aguas cristalinas de la Costa Esmeralda y las calas de Cerdeña.',
    allPorts: 'Todos los puertos',
    passengersPlaceholder: 'Pasajeros',
    passenger1: '1 pasajero',
    passengers2: '2 pasajeros',
    passengers3: '3 pasajeros',
    passengers4: '4 pasajeros',
    passengers5: '5 pasajeros',
    passengers6Plus: '6+ pasajeros',
    ourDestinations: 'Nuestros Destinos',
    categoryCoastline: 'Costa',
    categoryIslands: 'Islas',
    categoryBays: 'Calas',
    categoryOpen: 'Mar Abierto',
    boatsInSardinia: 'Barcos en Cerdeña',
    noBoatsTitle: 'No hay barcos disponibles',
    noBoatsMessage: 'Prueba a modificar los filtros de búsqueda',
    resetSearch: 'Restablecer búsqueda',
    boatFound: 'barco encontrado',
    boatsFound: 'barcos encontrados',
    noResultsTitle: 'No se han encontrado barcos.',
    noResultsMessage: 'Prueba a modificar los criterios de búsqueda',
    showAllBoats: 'Mostrar todos los barcos',
    verifiedFleet: 'Flota certificada y verificada',
    insurance: 'seguro',
    startDate: 'Fecha de salida',
    endDate: 'Fecha de regreso',
    noLicense: 'Sin licencia',
    // Hero
    premiumSelection: 'INSULA CHARTER PREMIUM SELECTION',
    heroDescription: 'Explora las calas más secretas de Cerdeña con nuestra flota de excelencia. El lujo se encuentra con la libertad.',
    // Benefits bar
    benefitFlexibility: 'Flexibilidad Total',
    benefitInstant: 'Alquiler Instantáneo',
    benefitCertified: 'Charters Certificados',
    // Catalog
    searchResults: 'Resultados de Búsqueda',
    catalogTitle: 'Catálogo de Barcos',
    searchResultsSubtitle: 'Hemos encontrado {count} embarcaciones para tus criterios.',
    catalogSubtitle: 'Descubre las embarcaciones más exclusivas seleccionadas para ti.',
    resetFilters: 'Restablecer Todos los Filtros',
    noResults: '¡Vaya! No hay embarcaciones disponibles para estos criterios.',
    noResultsHint: 'Prueba a modificar los filtros o ampliar los criterios de búsqueda.',
    resetFiltersBtn: 'Restablecer Filtros',
    loadingBoats: 'Cargando barcos...',
    loadingMap: 'Cargando mapa...',
    // Destinations section
    exclusiveDestinations: 'Los Destinos Más Exclusivos',
    exclusiveDestinationsDesc: 'De la Costa Esmeralda a las calas salvajes de la Ogliastra. Navega hacia el paraíso.',
    exploreMap: 'Explora el Mapa',
  },

  // ============================================
  // NAVBAR (extended)
  // ============================================
  navbarExt: {
    home: 'Inicio',
    fleet: 'Flota',
    excursions: 'Excursiones',
    destinations: 'Destinos',
    blog: 'Blog',
    vendorPanel: 'Panel Vendor',
    vendorRole: 'Vendor',
    lightTheme: 'Tema claro',
    darkTheme: 'Tema oscuro',
    navigation: 'Navegación',
    administration: 'Administración',
    account: 'Cuenta',
    settings: 'Configuración',
    services: 'Servicios',
  },

  // ============================================
  // FOOTER (extended)
  // ============================================
  footerExt: {
    home: 'Inicio',
    destinations: 'Destinos',
    support: 'Asistencia',
    helpCenter: 'Centro de Ayuda',
    termsConditions: 'Términos y Condiciones',
    cookiePrivacy: 'Cookies y Privacidad',
    kaskoInsurance: 'Seguro Kasko',
    securePayments: 'Pagos Seguros',
  },

  // ============================================
  // SEARCH SECTION
  // ============================================
  searchSection: {
    city: 'Ciudad',
    allCities: 'Todas',
    allCitiesLong: 'Todas las ciudades',
    noCities: 'No hay ciudades disponibles',
    dates: 'Fechas',
    dateStart: 'Inicio',
    dateEnd: 'Fin',
    times: 'Horarios',
    pickup: 'Recogida',
    dropoff: 'Devolución',
    guests: 'Huéspedes',
    passengers: 'Pasajeros',
    license: 'Licencia',
    licenseAll: 'Todas',
    licenseNo: 'No',
    search: 'Buscar',
  },

  // ============================================
  // CATALOG TOOLBAR & FILTERS
  // ============================================
  catalog: {
    // Toolbar
    filters: 'Filtros',
    searchPlaceholder: 'Buscar barco, puerto, descripción...',
    sortPriceAsc: 'Precio: de menor a mayor',
    sortPriceDesc: 'Precio: de mayor a menor',
    sortRating: 'Valoración',
    sortReviews: 'Más valorados',
    sortNewest: 'Novedades',
    sortName: 'Nombre A-Z',
    sortDefault: 'Ordenar por',
    viewGrid: 'Vista de cuadrícula',
    viewList: 'Vista de lista',
    viewMap: 'Vista de mapa',
    boatFound: 'barco encontrado',
    boatsFound: 'barcos encontrados',
    // Filters
    boatType: 'Tipo de Barco',
    dailyPrice: 'Precio Diario',
    priceRange: 'Rango disponible',
    passengerCapacity: 'Capacidad de Pasajeros',
    departureCity: 'Ciudad de Salida',
    allCities: 'Todas las ciudades',
    options: 'Opciones',
    noLicense: 'Sin licencia náutica',
    skipperAvailable: 'Patrón disponible',
    resetFilters: 'Restablecer Filtros',
    showResults: 'Mostrar resultados',
    // Pagination
    showing: 'Mostrando',
    of: 'de',
    results: 'resultados',
    prevPage: 'Página anterior',
    nextPage: 'Página siguiente',
    pageOf: 'Página {current} de {total}',
  },

  // ============================================
  // BOAT CARD (extended)
  // ============================================
  boatCardExt: {
    premiere: 'Insula Première',
    licenseRequired: 'Licencia Obligatoria',
    noLicense: 'Sin Licencia',
    unavailable: 'No disponible',
    startingFrom: 'Desde',
    from: 'desde',
    seasonalRate: 'Tarifa de temporada',
    perDay: '/día',
    perHalfDay: '/media jornada',
    perWeek: '/semana',
    perMonth: '/mes',
    shortStaySurcharge: 'Suplemento por estancia corta',
    length: 'Eslora',
    passengers: 'Pasajeros',
    cabins: 'Cabinas',
    bathrooms: 'Baños',
    engine: 'Motor',
    skipperIncluded: 'Patrón Incluido',
    skipperAvailable: 'Patrón Disponible',
    viewAlternatives: 'Ver Alternativas',
    exploreDetails: 'Explorar Detalles',
    alternatives: 'Alternativas',
    details: 'Detalles',
    license: 'Licencia',
    noLicenseShort: 'Sin Licencia',
    people: 'personas',
    forDays: 'por {days} días',
    premium: 'Premium',
  },

  // ============================================
  // DATE RANGE PICKER
  // ============================================
  datePicker: {
    title: 'Selecciona las fechas del alquiler',
    clearSelection: 'Borrar selección',
    confirmDates: 'Confirmar Fechas',
    boarding: 'Embarque',
    disembark: 'Desembarque',
    day: 'día',
    days: 'días',
    selectBoarding: 'Selecciona la fecha de embarque',
    selectDisembark: 'Selecciona la fecha de desembarque (haz clic en la misma fecha para un alquiler de un solo día)',
    available: 'Disponible',
    notAvailable: 'No disponible',
    halfDay: 'Media jornada',
    morningFree: 'Mañana libre',
    morningBooked: 'Mañana reservada',
    afternoonFree: 'Tarde libre',
    afternoonBooked: 'Tarde reservada',
    weekdayMon: 'Lun',
    weekdayTue: 'Mar',
    weekdayWed: 'Mié',
    weekdayThu: 'Jue',
    weekdayFri: 'Vie',
    weekdaySat: 'Sáb',
    weekdaySun: 'Dom',
    weekdayFullMon: 'Lunes',
    weekdayFullTue: 'Martes',
    weekdayFullWed: 'Miércoles',
    weekdayFullThu: 'Jueves',
    weekdayFullFri: 'Viernes',
    weekdayFullSat: 'Sábado',
    weekdayFullSun: 'Domingo',
    monthJan: 'Enero',
    monthFeb: 'Febrero',
    monthMar: 'Marzo',
    monthApr: 'Abril',
    monthMay: 'Mayo',
    monthJun: 'Junio',
    monthJul: 'Julio',
    monthAug: 'Agosto',
    monthSep: 'Septiembre',
    monthOct: 'Octubre',
    monthNov: 'Noviembre',
    monthDec: 'Diciembre',
  },

  // ============================================
  // BOAT TYPES
  // ============================================
  boatTypes: {
    yacht: 'Yate',
    sailboat: 'Velero',
    motorboat: 'Lancha motora',
    catamaran: 'Catamarán',
    dinghy: 'Neumática',
    jetski: 'Moto de Agua',
  },

  // ============================================
  // BOAT CARD
  // ============================================
  boatCard: {
    exclusive: 'Premium',
    pricePerDay: 'Precio diario',
    licenseRequired: 'Licencia requerida',
    noLicenseRequired: 'Sin licencia',
    capacity: 'Capacidad',
    length: 'Eslora',
    power: 'Potencia',
  },

  // ============================================
  // BOAT (New fields)
  // ============================================
  boat: {
    linkCopied: '¡Enlace copiado al portapapeles!',
    port: 'Puerto de Salida',
    enginePower: 'Potencia del Motor',
    skipperAvailable: 'Patrón Disponible',
    skipperIncluded: 'Patrón Incluido',
    hostessAvailable: 'Azafata Disponible',
    noLicense: 'Sin Licencia',
    licenseRequired: 'Licencia Requerida',
    amenities: 'Equipamiento a Bordo',
    extras: 'Servicios Extra',
    perStay: 'por alquiler',
    perDay: 'al día',
    perPerson: 'por persona',
    perPersonPerDay: 'por persona al día',
    coverImage: 'Foto de Portada',
    selectCover: 'Establecer como portada',
    freeService: 'Gratis',
    externalServicesTitle: 'Servicios disponibles en este puerto',
    externalServicesEmpty: 'No hay servicios externos disponibles en este puerto.',
    externalServicesLoading: 'Cargando servicios...',
    externalServicesPlaceholder: 'Esta embarcación ofrece servicios adicionales',
    externalServicesContactUs: 'Contáctanos para más información sobre los servicios disponibles.',
    availableServices: 'Servicios seleccionados para este barco',
    fromPrice: 'desde €{price}',
    nProvidersAvailable: '{count} proveedores disponibles',
    anonymousProvider: 'Proveedor',
    externalServiceCategoryMobility: 'Alquiler / Movilidad',
    externalServiceCategoryOther: 'Servicio',
    requestQuote: 'Solicitar presupuesto',
    requestQuoteTitle: 'Solicitar presupuesto',
    requestQuoteDate: 'Fecha preferida',
    requestQuoteGuests: 'Número de personas',
    requestQuoteNotes: 'Notas (opcional)',
    requestQuoteName: 'Tu nombre',
    requestQuoteEmail: 'Email',
    requestQuotePhone: 'Teléfono',
    requestQuoteSubmit: 'Enviar solicitud',
    requestQuoteSuccess: 'Solicitud enviada. El proveedor se pondrá en contacto contigo lo antes posible.',
    requestQuoteAuthHint: 'Deja tus datos de contacto para que el proveedor pueda responderte',
  },

  // ============================================
  // REVIEWS (Reseñas)
  // ============================================
  reviews: {
    title: 'Gestión de Reseñas',
    newReview: 'Nueva Reseña',
    editReview: 'Editar Reseña',
    noReviews: 'No hay reseñas',
    addFirst: 'Añade la primera reseña para tus barcos',
    authorName: 'Nombre del Autor',
    rating: 'Valoración',
    comment: 'Comentario',
    reviewDate: 'Fecha de la Reseña',
    adminResponse: 'Respuesta del Administrador',
    isVisible: 'Reseña visible al público',
    hidden: 'Oculta',
    stars: 'estrellas',
    star: 'estrella',
    averageRating: 'Media',
    totalReviews: 'reseñas',
    selectBoat: 'Selecciona un barco',
    deleteConfirm: '¿Quieres eliminar esta reseña?',
    created: 'Reseña creada correctamente',
    updated: 'Reseña actualizada correctamente',
    deleted: 'Reseña eliminada correctamente',
    showReview: 'Mostrar',
    hideReview: 'Ocultar',
  },

  // ============================================
  // BOAT DETAIL
  // ============================================
  boatDetail: {
    backButton: 'Explora la Flota',
    notFound: 'Barco no encontrado.',
    loginRequired: 'Inicia sesión para reservar.',
    selectDates: 'Selecciona las fechas desde la búsqueda.',
    characteristics: 'Características',
    description: 'Descripción',
    tagSkipper: 'Patrón Disponible',
    tagInsured: 'Seguro Incluido',
    tagSupport: 'Asistencia 24/7',
    whereIsIt: 'Puerto de salida',
    locationDescription: 'Situado en el puerto de {location}, uno de los más exclusivos de Cerdeña.',
    excellentPosition: 'Ubicación Estratégica',
    homePort: 'Puerto Base',
    rate: 'Tarifa',
    rental: 'Alquiler',
    passengersLabel: 'Pasajeros',
    extrasOptional: 'Servicios Extra (Opcionales)',
    fuelPolicy: 'Combustible',
    extrasTotal: 'Servicios extra',
    bookNow: 'RESERVA AHORA',
    processing: 'PROCESANDO...',
    protectionBadge: 'Protección InsulaCharter Garantizada',
    paymentMethod: 'Método de Pago',
    selectPaymentMethod: 'Selecciona un método de pago',
    noPaymentMethods: 'No hay métodos de pago guardados',
    addPaymentMethod: 'Añadir un método de pago',
    cashDescription: 'Paga en efectivo al recoger el barco',
    guaranteeRequired: 'Fianza requerida',
    guaranteeAmount: 'Importe de la fianza',
    selectGuaranteeCard: 'Selecciona la tarjeta para la fianza',
    cashNoCard: 'Pagar en efectivo (requiere confirmación del administrador)',
    cashNoCardDescription: 'Sin tarjeta de garantía, la reserva requiere confirmación manual',
    specifications: 'Especificaciones Técnicas',
    length: 'Eslora',
    beam: 'Manga',
    engine: 'Motor',
    fuelCapacity: 'Depósito',
    maxSpeed: 'Velocidad máxima',
  },

  // ============================================
  // DASHBOARD (GUEST)
  // ============================================
  dashboard: {
    title: 'Área Personal',
    greeting: 'Bienvenido de nuevo, {name}. Gestiona tus alquileres en Cerdeña.',
    profileSailor: 'Perfil de Navegante',
    menuUpcomingTrips: 'Próximos Alquileres',
    menuPaymentMethods: 'Métodos de Pago',
    menuSaved: 'Guardados',
    menuPersonalInfo: 'Información Personal',
    confirmedBookings: 'Reservas Confirmadas',
    pickupDate: 'Recogida',
    returnDate: 'Devolución',
    receipt: 'Recibo',
    cancelBooking: 'Cancelar',
    noTripsTitle: 'No hay alquileres confirmados',
    noTripsMessage: 'El mar te espera. ¡Empieza a planificar tu próxima aventura!',
    exploreBoats: 'Explora la Flota',
    historyAndCancelled: 'Historial y Canceladas',
    statusCancelled: 'Cancelada',
    myBookings: 'Mis Reservas',
    upcomingTrips: 'Próximos Alquileres',
    paymentMethods: 'Métodos de Pago',
    saved: 'Guardados',
    personalInfo: 'Información Personal',
    noBookings: 'No hay alquileres reservados',
    noBookingsDesc: 'El mar te espera. ¡Empieza a planificar tu próxima aventura!',
    savedComingSoon: 'Barcos Guardados',
    savedDescription: 'Función próximamente disponible. Pronto podrás guardar tus barcos favoritos.',
  },

  // ============================================
  // ADMIN DASHBOARD
  // ============================================
  admin: {
    title: 'Panel de Administración',
    subtitle: 'Gestión centralizada de InsulaCharter Cerdeña.',
    addBoat: 'Añadir Barco',
    bookingsTitle: 'Reservas',
    bookingsSubtitle: 'Gestiona las reservas',

    // Boat port/marina (for external services matching)
    boatPortMarina: 'Puerto/Marina',
    boatPortMarinaHint: 'Los servicios externos visibles para los clientes dependen del puerto seleccionado aquí.',
    boatPortMarinaNone: '— Sin puerto —',
    boatPortMarinaLoading: 'Cargando puertos...',

    // Role management
    changeRole: 'Cambiar Rol',
    changeRoleConfirm: '¿Seguro que quieres cambiar el rol de este usuario?',
    changeRoleSuccess: 'Rol actualizado correctamente',
    changeRoleAdminWarning: 'Esto concede acceso completo de administrador a la plataforma.',
    changeRoleWarningBoats: 'Este usuario tiene {count} barcos activos. Cambiar el rol desactivará sus anuncios.',
    changeRoleForce: 'Continuar de todos modos',
    cannotChangeOwnRole: 'No puedes cambiar tu propio rol',
    cannotDemoteLastAdmin: 'No se puede eliminar al último administrador de la plataforma',
    roleAlreadyAssigned: 'El usuario ya tiene este rol',
    confirmAdminRequired: 'Se requiere confirmación explícita para ascender a Administrador',
    invalidRole: 'Rol no válido',
    role_hub_internal_only: 'Esta cuenta (ADMIN o Proveedor de Servicios) se gestiona solo desde el hub, no aquí.',
    newRole: 'Nuevo rol',
    vendorStatusOption: 'Estado inicial del vendor',

    // Service Provider invitations
    inviteServiceProvider: 'Invitar Proveedor',
    inviteEmailLabel: 'Email del proveedor',
    inviteNameLabel: 'Nombre (opcional)',
    inviteDesc: 'Se enviará un email con un enlace de registro válido durante 48 horas.',
    inviteSend: 'Enviar Invitación',
    inviteSent: 'Invitación enviada correctamente',
    inviteAcceptTitle: 'Completar Registro',
    inviteAcceptDesc: 'Has sido invitado a unirte a InsulaCharter como Proveedor de Servicios.',

    // Preview links
    previewVendor: 'Vista previa Vendor',
    previewServiceProvider: 'Vista previa Proveedor',

    // Tabs
    tabDashboard: 'Resumen',
    tabCalendar: 'Calendario',
    tabMyBoats: 'Flota',
    tabReviews: 'Reseñas',
    tabBookings: 'Reservas de barcos',
    tabClientBookings: 'Reservas de Clientes',
    tabServices: 'Servicios a Bordo',
    calendarTitle: 'Calendario de Reservas',
    calendarSubtitle: 'Consulta todas las reservas de tu flota',
    fleetOverview: 'Resumen de Flota',

    // Stats
    statsOverview: 'Resumen General',
    statsTotalRevenue: 'Ingresos Totales',
    statsConfirmed: 'confirmadas',
    statsUniqueClients: 'Clientes Únicos',
    statsRegisteredClients: 'clientes registrados',
    statsActiveBoats: 'Barcos Activos',
    statsInFleet: 'en la flota',
    statsPending: 'Pendientes',
    statsToConfirm: 'por confirmar',

    // Economic averages
    economicAverages: 'Medias Económicas',
    avgBookingValue: 'Valor Medio de Reserva',
    avgPricePerDay: 'Precio Medio Diario',
    confirmationRate: 'Tasa de Confirmación',

    // Booking trends
    bookingTrends: 'Tendencia de Reservas',
    last30Days: 'Últimos 30 Días',
    confirmedBookings: 'reservas confirmadas',
    bookingStatus: 'Estado de Reservas',
    statusConfirmed: 'Confirmadas',
    statusPending: 'Pendientes',
    statusCancelled: 'Canceladas',

    // Pricing tabs
    tabPricingRules: 'Reglas de Precios',
    tabPricingCalendar: 'Calendario de Precios',
    tabTariffe: 'Tarifas',
    tabTariffeReadonly: 'Tarifas (solo lectura)',
    tabPricing: 'Precios y Promociones',

    // Pricing management (3-step flow)
    pricingTitle: 'Tarifas',
    pricingSubtitle: 'Explora propietarios, barcos y precios detallados',
    pricingBreadcrumbOwners: 'Todos los propietarios',
    pricingSelectOwner: 'Selecciona un propietario',
    pricingLoadingOwners: 'Cargando propietarios...',
    pricingNoOwnersFound: 'No se han encontrado propietarios',
    pricingFilterAll: 'Todos',
    pricingSearchOwner: 'Buscar nombre o email...',
    pricingColOwner: 'Propietario',
    pricingColEmail: 'Email',
    pricingColRole: 'Rol',
    pricingColBoats: 'Barcos',
    pricingBoatsOf: 'Barcos de',
    pricingBoatSingular: 'barco',
    pricingBoatPlural: 'barcos',
    pricingNoBoats: 'Este propietario no tiene barcos registrados',
    pricingColBoatName: 'Barco',
    pricingColType: 'Tipo',
    pricingColLength: 'Eslora',
    pricingColPriceDay: '€/día',
    pricingColPriceHalf: '€/media jornada',
    pricingColStatus: 'Estado',
    pricingBackToOwners: 'Volver a propietarios',
    pricingBackToBoats: 'Volver a los barcos de',
    pricingLoadingPricing: 'Cargando tarifas...',
    pricingSearchBoats: 'Buscar barco...',
    pricingAllTypes: 'Todos los tipos',
    pricingAllStatuses: 'Todos los estados',

    tabPricePolicies: 'Políticas de Precio',
    tabCoupons: 'Cupones y Promociones',
    tabInviteCodes: 'Códigos de Invitación',
    tabAmbassadors: 'Ambassadors',
    tabAmbassadorTiers: 'Niveles Ambassador',
    tabServicePlatformFee: 'Comisiones de Servicios',
    tabExternalServicesPayout: 'Pagos de Servicios',
    usersRetrievalError: 'Error al recuperar los usuarios',

    // Fleet management
    fleet: {
      title: 'Gestión de Flota',
      addBoat: 'Añadir Barco',
      filterAll: 'Todas',
      filterCompany: 'Empresas',
      filterVendor: 'Privados',
      filterPlatform: 'Plataforma',
      searchPlaceholder: 'Buscar barco, propietario, puerto...',
      allTypes: 'Todos los tipos',
      allPorts: 'Todos los puertos',
      clearFilters: 'Borrar filtros',
      expandAll: 'Expandir todo',
      collapseAll: 'Contraer todo',
      boat: 'barco',
      boats: 'barcos',
      owner: 'propietario',
      owners: 'propietarios',
      company: 'Empresa',
      vendor: 'Vendor Privado',
      platform: 'Plataforma',
      colBoat: 'Embarcación',
      colType: 'Tipo',
      colPort: 'Puerto',
      colCapacity: 'Capacidad',
      colPrice: 'Tarifa/Día',
      colActions: 'Acciones',
      rentalDay: 'día',
      rentalWeek: 'semana',
      rentalMonth: 'mes',
      viewDetails: 'Ver detalles',
      edit: 'Editar',
      delete: 'Eliminar',
      empty: 'No hay barcos en la flota',
      emptyHint: 'Empieza añadiendo tu primer barco',
      noResults: 'No se han encontrado barcos',
      noResultsHint: 'Prueba a modificar los filtros de búsqueda',
    },

    // Promotions tab
    tabPromotions: 'Promociones',
    tabSuspensions: 'Suspensiones',
    tabMobility: 'Servicios Externos',
    tabMobilityServices: 'Catálogo de Servicios',
    tabExtraCategories: 'Categorías de Servicios',
    tabExternalServices: 'Servicios Externos (API)',
    apiCatalogTitle: 'Catálogo de Servicios de InsulaServices',
    apiCatalogDesc: 'Servicios disponibles de insulaservices.it para los barcos. Haz clic en "Sincronizar" para actualizar.',
    apiCatalogSync: 'Sincronizar',
    apiCatalogSyncing: 'Sincronizando...',
    apiCatalogEmpty: 'No hay servicios disponibles. Prueba a sincronizar.',
    apiCatalogError: 'Error al contactar con insulaservices.it',
    apiCatalogQuote: 'Bajo petición',
    apiCatalogPerPerson: '/persona',
    extraCategoriesTitle: 'Categorías de Servicios',
    extraCategoriesDesc: 'Crea y gestiona las categorías de los servicios extra. Las categorías marcadas como "externas" son visibles para los clientes y seleccionables por los Proveedores de Servicios.',
    extraCategoriesNew: 'Nueva categoría',
    extraCategoriesEdit: 'Editar categoría',
    extraCategoriesEmpty: 'No hay categorías configuradas',
    extraCategoriesSlug: 'Slug (ID único)',
    extraCategoriesLabel: 'Etiqueta',
    extraCategoriesDescription: 'Descripción',
    extraCategoriesIcon: 'Icono',
    extraCategoriesIconHint: 'Nombre de un icono Lucide (p. ej. Bike, Camera, Utensils, Anchor)',
    extraCategoriesColor: 'Color de la insignia',
    extraCategoriesSortOrder: 'Orden',
    extraCategoriesVisibility: 'Visibilidad',
    extraCategoriesExternal: 'Externa (visible para los clientes)',
    extraCategoriesExternalShort: 'externa',
    extraCategoriesInternal: 'Interna (solo administrador)',
    extraCategoriesInternalShort: 'interna',
    extraCategoriesProtected: 'Categoría protegida — no se puede eliminar',
    extraCategoriesProtectedHint: 'Las categorías protegidas no pueden cambiar de slug ni de visibilidad',
    extraCategoriesUsage: 'en uso',
    extraCategoriesMoveUp: 'Subir',
    extraCategoriesMoveDown: 'Bajar',
    extraCategoriesValidation: 'El slug y la etiqueta son obligatorios',
    extraCategoriesCreated: 'Categoría creada',
    extraCategoriesUpdated: 'Categoría actualizada',
    extraCategoriesDeleted: 'Categoría eliminada',
    extraCategoriesConfirmDelete: '¿Eliminar definitivamente esta categoría?',
    mobilityServices: 'Servicios de Movilidad',
    mobilityServicesDesc: 'Gestiona bicicletas, patinetes, scooters y traslados disponibles para los clientes',
    noMobilityServices: 'No hay servicios de movilidad configurados',
    tabTransferOverview: 'Traslados',
    transferOverview: 'Resumen de Traslados',
    unassigned: 'Sin asignar',
    reassign: 'Reasignar',
    tabServiceProviders: 'Proveedores de Servicios',
    tabServiceRequests: 'Solicitudes de Servicio',
    serviceProviders: 'Proveedores de Servicios',
    serviceProvidersDesc: 'Gestiona los proveedores que prestan servicios de movilidad y traslados',
    addProvider: 'Añadir Proveedor',
    noProviders: 'No hay proveedores registrados',
    selectUser: 'Seleccionar Usuario',
    selectService: 'Seleccionar Servicio',
    maxCapacity: 'Capacidad Máxima',
    serviceRequests: 'Solicitudes de Servicio',
    serviceRequestsDesc: 'Resumen de todas las solicitudes de servicio de las reservas',
    noServiceRequests: 'No hay solicitudes de servicio',
    // Mobility sub-tab extras
    tabMobilityOverview: 'Resumen',
    mobilityOverview: 'Resumen de Movilidad',
    mobilityOverviewDesc: 'Estadísticas globales de proveedores y solicitudes de servicio',
    mobilityProvidersTotal: 'Proveedores totales',
    mobilityProvidersActive: 'Proveedores activos',
    mobilityProvidersInactive: 'Proveedores inactivos',
    mobilityRequestsTotal: 'Solicitudes totales',
    mobilityTopProviders: 'Top 5 proveedores (solicitudes completadas)',
    mobilityNoTopProviders: 'Ningún proveedor tiene solicitudes completadas todavía',
    mobilityRefresh: 'Actualizar',
    mobilityLoadError: 'Error al cargar los datos de movilidad',
    mobilityOpenSpDashboard: 'Abrir panel del SP',
    mobilityPendingBadge: '{count} pendientes',
    mobilityStatusActive: 'Activo',
    mobilityStatusInactive: 'Inactivo',
    mobilityEditName: 'Nombre',
    mobilityEditPrice: 'Precio (€)',
    mobilityEditPriceType: 'Tipo de precio',
    mobilityEditDescription: 'Descripción',
    mobilityEnable: 'Activar',
    mobilityDisable: 'Desactivar',
    mobilityLabelCapacity: 'Cap.',
    mobilityLabelProvider: 'Proveedor',
    mobilityLabelQuantity: 'Cant.',
    mobilityToggleError: 'No se ha podido actualizar el estado del servicio',
    mobilitySaveError: 'No se han podido guardar los cambios',
    mobilityLoadProvidersError: 'No se han podido cargar los proveedores',
    mobilityLoadRequestsError: 'No se han podido cargar las solicitudes',
    // External services moderation
    externalServicesTitle: 'Servicios Externos',
    externalServicesDesc: 'Modera y gestiona los servicios creados por los Proveedores de Servicios',
    externalServicesPending: 'Pendiente de aprobación',
    externalServicesApprove: 'Aprobar',
    externalServicesReject: 'Rechazar',
    externalServicesRejectReason: 'Motivo del rechazo',
    externalServicesNotes: 'Notas (visibles para el SP)',
    externalServiceCreator: 'Creado por',
    externalServiceCreatorAdmin: 'Admin (plataforma)',
    externalServicePorts: 'Puertos operativos',
    externalServiceNoPort: 'Ningún puerto asociado',
    // Price type labels
    priceType_per_stay: 'Por alquiler',
    priceType_per_day: 'Por día',
    priceType_per_night: 'Por noche',
    priceType_per_person: 'Por persona',
    priceType_per_person_per_day: 'Por persona/día',
    priceType_per_person_per_night: 'Por persona/noche',
    confirmDelete: '¿Seguro que quieres eliminarlo?',
    tabPoi: 'Puntos de Interés',
    tabPorts: 'Puertos',
    promoTitle: 'Título',
    promoSubtitle: 'Subtítulo',
    promoDescription: 'Descripción',
    promoImage: 'Imagen',
    promoCtaText: 'Texto CTA',
    promoCtaLink: 'Enlace CTA',
    promoBadge: 'Insignia',
    promoStartDate: 'Fecha de Inicio',
    promoEndDate: 'Fecha de Fin',
    promoActive: 'Activa',
    promoOrder: 'Orden',
    promoNew: 'Nueva Promoción',
    promoEdit: 'Editar Promoción',
    promoDelete: 'Eliminar Promoción',
    promoDeleteConfirm: '¿Seguro que quieres eliminar esta promoción?',
    promoCreated: 'Promoción creada correctamente',
    promoUpdated: 'Promoción actualizada correctamente',
    promoDeleted: 'Promoción eliminada correctamente',
    promoNoResults: 'No se han encontrado promociones',
    promoAlwaysVisible: 'Siempre visible',
    promoSave: 'Guardar',
    promoCancel: 'Cancelar',
    promoUploadImage: 'Subir imagen',
    promoOrImageUrl: 'o introduce la URL de la imagen',
    promoToggleActive: 'Activar/Desactivar',
    promoReorderHint: 'Usa las flechas para reordenar',
    promoMoveUp: 'Subir',
    promoMoveDown: 'Bajar',

    // Trends tab
    tabTrends: 'Tendencias',
    trendsTotalRevenue: 'Ingresos del Periodo',
    trendsMonthlyAvg: 'Media Mensual',
    trendsPerMonth: 'al mes',
    trendsTrend: 'Tendencia',
    trendsVsPrev: 'vs periodo anterior',
    trendsBookings: 'Reservas',
    trendsRevenue: 'Ingresos',

    // Recent bookings table
    recentBookings: 'Últimas Reservas',
    tableDate: 'Fecha',
    tableBoat: 'Barco',
    tablePickupReturn: 'Recogida/Devolución',
    tableValue: 'Valor',
    tableStatus: 'Estado',
    noBookingsYet: 'Todavía no hay reservas',
    clientProfile: 'Perfil del Cliente',
    bookingHistory: 'Historial de Reservas',
    totalSpent: 'Total Gastado',
    cancellationReason: 'Motivo de cancelación',
    confirmBooking: 'Confirmar reserva',
    cancelBooking: 'Cancelar reserva',
    completeBooking: 'Completar reserva',
    refundDeposit: 'Reembolsar fianza',
    depositRefunded: 'Fianza reembolsada',

    // Boats table
    tableVessel: 'Embarcación',
    tablePort: 'Puerto',
    tableRate: 'Tarifa',
    tableActions: 'Acciones',

    // Bookings table
    tableClients: 'Clientes',
    tablePeriod: 'Periodo',
    tableTotal: 'Total',
    tablePaymentStatus: 'Pago',
    vendorSuspended: 'Vendor suspendido',
    vendorBookingsSuspended: 'Reservas suspendidas',
    boatName: 'Barco',
    email: 'Email',
    embarkation: 'Embarque',
    disembarkation: 'Desembarque',
    deposit: 'Fianza',

    // Booking list/calendar view
    allStatuses: 'Todas',
    allPaymentStatuses: 'Todos los pagos',
    paymentPending: 'Pendiente de pago',
    paymentPaid: 'Pagado',
    paymentPartial: 'Parcial',
    paymentRefunded: 'Reembolsado',
    calendarView: 'Calendario',
    listView: 'Lista',
    searchGuest: 'Buscar cliente...',
    cancelWithReason: 'Cancelar con motivo',
    cancelConfirmMessage: '¿Seguro que quieres cancelar esta reserva?',
    cancelReasonPlaceholder: 'Motivo de la cancelación (opcional)',

    // Summary cards
    pendingBookings: 'Pendientes',
    confirmedRevenue: 'Ingresos Confirmados',

    // Booking detail modal
    bookingDetail: 'Detalle de la Reserva',
    guestInfo: 'Información del Cliente',
    firstName: 'Nombre',
    boatInfo: 'Información del Barco',
    port: 'Puerto',
    rentalDetails: 'Detalles del Alquiler',
    experienceDetails: 'Detalles de la Experiencia',
    priceSummary: 'Resumen del Precio',
    basePrice: 'Precio base',
    insuranceFee: 'Seguro',
    extras: 'Extras',
    specialRequests: 'Solicitudes Especiales',
    downloadReceipt: 'Recibo',
    noBookingsFound: 'No se han encontrado reservas',

    // Reversible bookings
    reversibleBookings: 'Reservas Reversibles',
    reversibleBookingsSubtitle: 'Puedes restaurar el estado anterior',
    reverse: 'Restaurar',
    undo: 'Deshacer',

    // Calendar overview
    boatsOverview: 'Resumen de Barcos',
    confirmedShort: 'conf.',
    pendingShort: 'pendientes',
    blockedShort: 'bloqueados',

    // Services section
    includedServices: 'Equipamiento a Bordo',
    includedServicesSubtitle: 'Gestiona el equipamiento incluido en los barcos',
    addEquipment: 'Añadir Equipamiento',
    extraServices: 'Servicios Extra (de Pago)',
    extraServicesSubtitle: 'Gestiona los servicios extra que se pueden añadir a los alquileres. El precio se define para cada barco.',
    addExtraService: 'Añadir Servicio Extra',

    // Extras approval (admin)
    extraFilterAll: 'Todos',
    extraFilterPlatform: 'Plataforma',
    extraFilterVendors: 'Vendor',
    extraFilterPending: 'Pendientes',
    extraCreatorPlatform: 'Plataforma',
    extraCreatorLabel: 'Creado por',
    extraApprove: 'Aprobar',
    extraReject: 'Rechazar',
    extraRejectNotes: 'Motivo del rechazo',
    extraRejectNotesPlaceholder: 'Explica el motivo del rechazo...',
    extraPendingCount: 'extras pendientes',
    extraApproved: 'Extra aprobado',
    extraRejected: 'Extra rechazado',
    extraApproveError: 'Error al aprobar',
    extraRejectError: 'Error al rechazar',
    extraPromote: 'Hacer global',
    extraPromoted: 'Extra promovido a servicio global de la plataforma',
    extraPromoteError: 'Error al promover',
    extraPromoteConfirm: '¿Hacer este extra disponible para todos los barcos de la plataforma? El vendor perderá la propiedad exclusiva.',

    // Audit History
    auditTitle: 'Historial de Operaciones',
    auditSubtitle: 'Historial completo de las operaciones sobre servicios extra para trazabilidad y resolución de disputas',
    auditTotalEntries: 'operaciones registradas',
    auditNoEntries: 'No hay operaciones registradas',
    auditDetails: 'Detalles de la operación',
    auditPage: 'Página',

    tableService: 'Servicio',
    tableDescription: 'Descripción',
    tableIcon: 'Icono',

    // Boat modal
    modalNewBoat: 'Nuevo Barco InsulaCharter',
    modalEditBoat: 'Editar Barco InsulaCharter',
    formBoatName: 'Nombre del Barco',
    formBoatNamePlaceholder: 'p. ej.: Azzurra',
    formPort: 'Puerto Base',
    formPortPlaceholder: 'p. ej.: Porto Cervo',
    formPricePerDay: 'Precio Diario (€)',
    formInsuranceFee: 'Seguro (€)',
    formDescription: 'Descripción',
    formDescriptionPlaceholder: 'Describe las características de este barco...',

    // Photos section
    photosSection: 'Fotos del Barco',
    photoCover: 'Portada',
    photoSetCover: 'Usar como Portada',
    addPhoto: 'Añadir Foto',
    addPhotoMaxReached: 'Añadir Foto (Máximo alcanzado)',

    // Specifications
    specifications: 'Especificaciones Técnicas',
    formLength: 'Eslora (m)',
    formBeam: 'Manga (m)',
    formCapacity: 'Capacidad de Pasajeros',
    formEngine: 'Motorización',
    formLicenseRequired: 'Requiere Licencia Náutica',

    // Services in boat
    onboardEquipment: 'Equipamiento a Bordo',
    extraServicesPaid: 'Servicios Extra (de pago)',
    extraServicesCustomPrice: 'Define precios personalizados para este barco',

    // Buttons
    saveChanges: 'Guardar Cambios',
    createListing: 'Publicar Barco',

    // Equipment modal
    modalNewEquipment: 'Nuevo Equipamiento',
    modalEditEquipment: 'Editar Equipamiento',
    formServiceId: 'ID del Servicio',
    formServiceIdPlaceholder: 'p. ej.: bimini_top',
    formServiceIdHelper: 'Usa solo letras minúsculas y guiones bajos',
    formServiceName: 'Nombre del Servicio',
    formServiceNamePlaceholder: 'p. ej.: Bimini Top',
    formServiceDescriptionPlaceholder: 'Describe el equipamiento...',
    formIconOptional: 'Icono (opcional)',
    iconDefault: 'Info (predeterminado)',
    iconAnchor: 'Ancla',
    iconLifeBuoy: 'Salvavidas',
    iconCompass: 'Brújula',
    iconSun: 'Sol',
    iconWaves: 'Olas',
    iconWind: 'Viento',
    iconFuel: 'Combustible',
    iconRadio: 'Radio',
    iconGps: 'GPS',

    // Extra modal
    modalNewExtra: 'Nuevo Servicio Extra',
    modalEditExtra: 'Editar Servicio Extra',
    formExtraIdPlaceholder: 'p. ej.: skipper_service',
    formExtraNamePlaceholder: 'p. ej.: Patrón Profesional',
    formExtraDescriptionPlaceholder: 'Describe el servicio extra...',
    extraPriceInfo: 'El precio del servicio se definirá individualmente para cada barco.',

    // Multilingual translations
    translationsSection: 'Traducciones',
    translationsHelper: 'Introduce las traducciones para cada idioma soportado',
    translationsHelperAuto: 'Introduce el texto en italiano y haz clic en "Traducir automáticamente" para generar las demás traducciones.',
    autoTranslate: 'Traducir automáticamente',
    translating: 'Traduciendo...',
    translationComplete: '¡Traducción completada!',
    translationFailed: 'Error en la traducción',
    enterItalianFirst: 'Introduce primero el texto en italiano',
    sourceLang: 'Idioma de origen',
    labelIT: 'Nombre (Italiano)',
    labelEN: 'Nombre (Inglés)',
    labelDE: 'Nombre (Alemán)',
    descriptionIT: 'Descripción (Italiano)',
    descriptionEN: 'Descripción (Inglés)',
    descriptionDE: 'Descripción (Alemán)',
    langIT: 'Italiano',
    langEN: 'Inglés',
    langDE: 'Alemán',

    // Category options
    formCategory: 'Categoría',
    categoryGeneral: 'Servicio general',
    categorySafety: 'Seguridad',
    categoryComfort: 'Confort',
    categoryNavigation: 'Navegación',
    categoryEntertainment: 'Entretenimiento',
    categorySpecial: 'Servicio especial (insignia verde)',

    // Blocked Dates
    allBoats: 'Todos los barcos',
    blockDates: 'Bloquear Fechas',
    blockDatesTitle: 'Bloquear Fechas',
    blockedPeriods: 'Periodos Bloqueados',
    blocked: 'bloqueados',
    unblock: 'Desbloquear',
    blockingFor: 'Bloqueo de fechas para',
    startDate: 'Fecha de inicio',
    endDate: 'Fecha de fin',
    blockReason: 'Motivo (opcional)',
    blockReasonPlaceholder: 'p. ej.: Mantenimiento, Uso personal...',
    blockWarning: 'Las fechas bloqueadas no estarán disponibles para nuevos alquileres y se mostrarán como "no disponibles" a los usuarios.',
    confirmBlock: 'Bloquear Fechas',
    selectBoatFirst: 'Selecciona primero un barco',
    selectDatesFirst: 'Selecciona las fechas',
    datesBlocked: 'Fechas bloqueadas correctamente',
    datesUnblocked: 'Fechas desbloqueadas',
    confirmUnblock: '¿Quieres desbloquear estas fechas?',
    tabSettings: 'Configuración',
    tabClients: 'Clientes',
    tabClientManagement: 'Clientes',

    // Clients section
    clientsTitle: 'Gestión de Clientes',
    searchClients: 'Buscar por nombre o email...',
    searchBookings: 'Buscar cliente, email...',
    noClients: 'No hay clientes registrados',
    tableClient: 'Cliente',
    tableEmail: 'Email',
    tableBookingsCount: 'Reservas',
    tableTotalSpent: 'Total Gastado',
    tableRegistered: 'Registrado el',
    registeredOn: 'Registrado el',
    totalBookings: 'Total',
    viewClient: 'Ver Cliente',
    clientConfirmedBookings: 'Confirmadas',
    clientPendingBookings: 'Pendientes',
    clientCancelledBookings: 'Canceladas',
    emailVerified: 'Email Verificado',
    emailNotVerified: 'Email No Verificado',

    // Admin User Management
    userManagement: 'Gestión Avanzada',
    userManagementDesc: 'Acciones administrativas para este usuario',
    resetEmailVerification: 'Restablecer Verificación de Email',
    resetEmailVerificationDesc: 'Restablece el estado de verificación del email. El usuario deberá verificar su email de nuevo.',
    resetEmailVerificationSuccess: 'Verificación de email restablecida correctamente',
    resetPassword: 'Restablecer Contraseña',
    resetPasswordDesc: 'Envía un email de restablecimiento de contraseña al usuario.',
    resetPasswordSuccess: 'Email de restablecimiento de contraseña enviado',
    resetPasswordEmailFailed: 'No se ha podido enviar el email. Token generado para uso manual.',
    emailNotConfigured: 'Email no configurado. Token generado para uso manual.',
    userNotFound: 'Usuario no encontrado',
    confirmAction: 'Confirmar Acción',
    confirmResetEmailVerification: '¿Seguro que quieres restablecer la verificación de email de este usuario?',
    confirmResetPassword: '¿Seguro que quieres enviar un email de restablecimiento de contraseña a este usuario?',
    // Suspension
    suspendUser: 'Suspender Usuario',
    suspendUserDesc: 'Bloquea el acceso a la plataforma e impide nuevas reservas.',
    unsuspendUser: 'Reactivar Usuario',
    unsuspendUserDesc: 'Restaura el acceso completo a la plataforma.',
    suspendUserSuccess: 'Usuario suspendido correctamente',
    unsuspendUserSuccess: 'Usuario reactivado correctamente',
    confirmSuspendUser: '¿Seguro que quieres suspender a este usuario? Ya no podrá acceder a la plataforma.',
    confirmUnsuspendUser: '¿Seguro que quieres reactivar a este usuario?',
    suspensionReason: 'Motivo de la suspensión',
    suspensionReasonPlaceholder: 'P. ej.: Incumplimiento de los términos de servicio, pagos fraudulentos...',
    suspended: 'Suspendido',
    suspendedSince: 'Suspendido desde',
    accountSuspended: 'Cuenta Suspendida',
    accountSuspendedDesc: 'Tu cuenta ha sido suspendida. Contacta con soporte para más información.',
    suspendCompanyDesc: 'Bloquea el acceso a la plataforma, impide nuevas reservas y oculta los barcos del catálogo.',

    // Monitoring / Logs
    tabMonitoring: 'Monitorización',
    tabLogs: 'Registro de Eventos',
    tabRawConsole: 'Consola raw',
    logs: {
      title: 'Registros del Sistema',
      description: 'Registro de eventos y actividad de la plataforma',
      filterCategory: 'Categoría',
      filterLevel: 'Nivel',
      filterFrom: 'Desde',
      filterTo: 'Hasta',
      filterSearch: 'Buscar en el mensaje...',
      filterActor: 'Usuario (ID)',
      reset: 'Restablecer',
      exportCsv: 'Exportar CSV',
      columns: {
        timestamp: 'Fecha',
        level: 'Nivel',
        category: 'Categoría',
        action: 'Acción',
        actor: 'Usuario',
        target: 'Objetivo',
        message: 'Mensaje',
        ip: 'IP',
        details: 'Detalles',
      },
      detailsTitle: 'Detalles del evento',
      metadata: 'Metadatos',
      requestId: 'Request ID',
      empty: 'No hay eventos',
      loading: 'Cargando registros...',
      page: 'Página {{n}} de {{total}}',
      levels: {
        all: 'Todos',
        info: 'Info',
        warn: 'Aviso',
        error: 'Error',
      },
      categories: {
        all: 'Todas',
        auth: 'Autenticación',
        ambassador: 'Ambassador',
        booking: 'Reservas',
        payment: 'Pagos',
        admin: 'Admin',
        system: 'Sistema',
        http: 'HTTP',
      },
    },

    bookings: {
      actionCancel: 'Cancelar',
      actionHardDelete: 'Eliminar definitivamente',
      paymentMethod: 'Método de pago',
      amountPaid: 'Importe pagado',
      confirmCancel: 'Confirmar cancelación',

      hardDeleteTitle: 'Eliminación definitiva',
      hardDeleteWarningTitle: 'ELIMINACIÓN DEFINITIVA — IRREVERSIBLE',
      hardDeleteWarning: 'Esta operación elimina la reserva de la base de datos para siempre. Úsala solo con datos de prueba, nunca en producción.',
      hardDeleteConfirmType: 'Para confirmar, escribe "{keyword}"',
      hardDeleteConfirm: 'Eliminar definitivamente',

      cancelRefundTitle: 'Cancelar reserva y reembolsar',
      refundPreview: 'Importe a reembolsar',
      refundPolicy: 'Política aplicada',
      refundViaMollie: 'Reembolsar automáticamente vía Mollie',
      refundViaMollieDesc: 'Mollie procesa el reembolso en la misma tarjeta utilizada por el cliente.',
      refundManualWarningTitle: 'Se requiere reembolso manual',
      refundManualWarning: 'Pago vía {gateway}: después de la cancelación deberás marcar manualmente el reembolso como completado desde el detalle de la reserva.',
      refundPendingBox: 'Se requiere reembolso manual',
      markRefunded: 'Marcar como reembolsado',
      waiveRefund: 'Renunciar al reembolso',
      refundNote: 'Nota (opcional)',
      refundNotePlaceholder: 'Motivo de la cancelación o nota interna...',

      statusRefundPending: 'Reembolso pendiente',
      statusRefundProcessing: 'Reembolso en curso',
      statusRefundFailed: 'Reembolso fallido',
      statusRefundWaived: 'Reembolso rechazado',

      toastCancelSuccess: 'Reserva cancelada',
      toastRefundedMollie: 'Reembolsada vía Mollie',
      toastRefundPending: 'Cancelada. Reembolso manual pendiente',
      toastRefundProcessing: 'Cancelada. Reembolso en proceso',
      toastRefundFailed: 'Reembolso de Mollie fallido — reinténtalo manualmente',
      toastDeleted: 'Reserva eliminada definitivamente',
      toastMarkedRefunded: 'Reserva marcada como reembolsada',
      toastRefundWaived: 'Renuncia al reembolso registrada',

      forceRefundTitle: 'Reembolso de Mollie no registrado',
      forceRefundDesc: 'Esta reserva se canceló pero el reembolso de Mollie nunca se ejecutó. Puedes forzarlo manualmente ahora.',
      forceRefundPaid: 'Importe pagado',
      forceRefundAmount: 'Importe a reembolsar',
      forceRefundBtn: 'Forzar reembolso en Mollie',
      forceRefundConfirm: '¿Confirmas el reembolso de €{amount} en Mollie?',
      forceRefundSuccess: 'Reembolso procesado en Mollie (€{amount})',
      forceRefundError: 'Error en el reembolso',
      forceRefundMollieId: 'ID de pago de Mollie',
    },

    settings: {
      securityTitle: 'Seguridad y Pruebas',
      securityDesc: 'Operaciones destructivas y funciones exclusivas para pruebas',
      hardDeleteToggle: 'Permitir eliminación definitiva de reservas',
      hardDeleteDescription: 'Solo para entornos de prueba. Si está activo, los administradores podrán eliminar permanentemente las reservas de la base de datos. Mantener desactivado en producción.',
      hardDeleteOn: 'ACTIVO',
      hardDeleteOff: 'INACTIVO',
      hardDeleteWarningProd: 'ATENCIÓN: en producción esta opción debe permanecer DESACTIVADA. Las eliminaciones son irreversibles y borran datos históricos de pagos, recibos y auditoría.',
    },
  },

  // ============================================
  // SETTINGS
  // ============================================
  settings: {
    title: 'Configuración',
    subtitle: 'Gestiona la configuración del sistema',
    saved: 'Configuración guardada',
    invalidDays: 'Introduce un valor entre 1 y 90',

    // Dashboard Layout
    dashboardLayout: 'Diseño del Panel',
    dashboardLayoutDesc: 'Elige cómo agrupar las pestañas en los paneles de administrador y vendor',
    layoutAdmin: 'Panel Admin',
    layoutVendor: 'Panel Vendor',
    layoutA: 'Compacto',
    layoutADesc: 'Agrupa las pestañas en pocas macrosecciones',
    layoutB: 'Prioridad operativa',
    layoutBDesc: 'Equilibrio entre visibilidad y agrupación',
    layoutC: 'Ultracompacto',
    layoutCDesc: 'Número mínimo de pestañas principales',
    layoutTabs: 'pestañas',
    layoutCurrent: 'Actual',

    // Admin tab group labels
    layoutAdminFleet: 'Flota',
    layoutAdminOperations: 'Operaciones',
    layoutAdminClientsServices: 'Clientes y Servicios',
    layoutAdminMarketplace: 'Marketplace',
    layoutAdminFinance: 'Finanzas',
    layoutAdminManagement: 'Gestión',

    // Vendor tab group labels
    layoutVendorFleet: 'Flota',
    layoutVendorOperations: 'Operaciones',
    layoutVendorServicesClients: 'Servicios y Clientes',
    layoutVendorManagement: 'Gestión',

    // Sub-tab labels
    subtabStats: 'Estadísticas',
    subtabVendors: 'Vendors',
    subtabBoatApproval: 'Aprobación de Barcos',
    subtabRevenue: 'Ingresos',
    subtabPayouts: 'Pagos',
    subtabPlatformStats: 'Plataforma',
    autoCancellation: 'Cancelación Automática de Reservas Pendientes',
    autoCancellationDesc: 'Cuando está activado, las reservas en estado "Pendiente" se cancelarán automáticamente transcurrido el número de días especificado.',
    enableAutoCancel: 'Activar cancelación automática',
    autoCancelEnabled: 'Las reservas pendientes caducadas se cancelarán automáticamente',
    autoCancelDisabled: 'Las reservas pendientes no se cancelarán automáticamente',
    daysBeforeCancel: 'Días antes de la cancelación',
    daysBeforeCancelDesc: 'Número de días tras los cuales se cancela una reserva pendiente (1-90)',
    howItWorks: 'Cómo funciona',
    howItWorksDesc: 'El sistema comprueba cada día a medianoche las reservas en estado "Pendiente" (PENDING). Si una reserva se creó hace más días de los especificados y todavía no se ha confirmado, se cancela automáticamente con el motivo "Caducidad automática".',

  },

  // ============================================
  // AUTH - LOGIN
  // ============================================
  login: {
    title: 'Bienvenido de nuevo',
    subtitle: 'Inicia sesión en tu cuenta',
    emailLabel: 'Email',
    emailPlaceholder: 'tu@email.com',
    passwordLabel: 'Contraseña',
    passwordPlaceholder: '••••••••',
    submitButton: 'Iniciar sesión',
    submittingButton: 'Iniciando sesión...',
    noAccount: '¿No tienes una cuenta? Regístrate',
    partnerRedirect: 'Los partners deben iniciar sesión en partner.insulacharter.it',
    testAccounts: 'Cuentas de prueba:',
    testGuest: 'Invitado: turista@example.com',
    testAdmin: 'Admin: info@insulacharter.it',
    testPassword: 'Contraseña: InsulaHost2026!',
    forgotPassword: '¿Olvidaste tu contraseña?',
  },

  // ============================================
  // AUTH - FORGOT PASSWORD
  // ============================================
  forgotPassword: {
    title: 'Contraseña olvidada',
    description: 'Introduce tu email y te enviaremos un enlace para restablecer tu contraseña.',
    submitButton: 'Enviar enlace de restablecimiento',
    emailSentTitle: '¡Email enviado!',
    emailSentDescription: 'Si el email está registrado, recibirás un enlace para restablecer la contraseña. Revisa también la carpeta de spam.',
    backToLogin: 'Volver al inicio de sesión',
  },

  // ============================================
  // AUTH - RESET PASSWORD
  // ============================================
  resetPassword: {
    title: 'Nueva contraseña',
    description: 'Elige una nueva contraseña para tu cuenta.',
    newPasswordLabel: 'Nueva contraseña',
    newPasswordPlaceholder: 'Introduce la nueva contraseña',
    confirmPasswordLabel: 'Confirmar contraseña',
    confirmPasswordPlaceholder: 'Repite la nueva contraseña',
    submitButton: 'Restablecer contraseña',
    successTitle: '¡Contraseña restablecida!',
    successDescription: 'Tu contraseña se ha actualizado. Serás redirigido al inicio de sesión...',
    invalidLink: 'Enlace no válido',
    invalidLinkDescription: 'El enlace de restablecimiento falta o no es válido. Solicita un nuevo enlace.',
    requestNewLink: 'Solicitar nuevo enlace',
    passwordMismatch: 'Las contraseñas no coinciden',
  },

  // ============================================
  // AUTH - PARTNER LOGIN
  // ============================================
  partnerLogin: {
    title: 'Portal de Partners',
    subtitle: 'InsulaCharter — Área Restringida',
    sectionLabel: 'Acceso Partners',
    emailPlaceholder: 'email@ejemplo.com',
    submit: 'Iniciar sesión',
    submitting: 'Iniciando sesión...',
    accessDenied: 'Esta área está reservada para partners. Inicia sesión desde el sitio principal.',
    copyright: 'Todos los derechos reservados.',
  },

  // ============================================
  // PERFIL PARTNER (completado)
  // ============================================
  partnerProfile: {
    tab: { anagrafica: 'Datos', documenti: 'Documentos', account: 'Cuenta' },
    header: { verified: 'Verificado', pending: 'Pendiente', ibanMissing: 'IBAN sin configurar', manageIban: 'Ajustes' },
    role: { VENDOR: 'Operador', COMPANY: 'Empresa', ADMIN: 'Admin' },
    completionTitle: 'Progreso del perfil',
    missing: 'Faltan',
    allDone: 'Perfil completo',
    loading: 'Cargando perfil…',
    loadError: 'Error al cargar el perfil',
    saved: 'Perfil actualizado',
    saveError: 'Error al guardar',
    notSet: 'No definido',
    managePayout: 'Gestiona en Configuración → Pagos e Ingresos',
    save: 'Guardar perfil',
    saving: 'Guardando…',
    badgeComplete: 'Completo',
    badgeMissingOne: 'falta',
    badgeMissingMany: 'faltan',
    bioPlaceholder: 'Describe tu actividad (mín. 30 caracteres)…',
    bioHelper: 'Al menos 30 caracteres.',
    seasonHint: 'Predeterminado para toda la flota. Déjalo vacío para "siempre abierto".',
    seasonFrom: 'Desde',
    seasonTo: 'Hasta',
    docsHint: 'Los documentos son verificados por el equipo de InsulaCharter.',
    docsUpload: 'Subir',
    docsReplace: 'Reemplazar',
    docStatusMissing: 'Por subir',
    docStatusPending: 'En revisión',
    docStatusApproved: 'Verificado',
    docStatusRejected: 'Rechazado',
    docUploadError: 'Error al subir',
    docUploadOk: 'Documento subido',
    emailVerifyTitle: 'Verificación de email',
    changePassword: 'Cambiar contraseña',
    currentPassword: 'Contraseña actual',
    newPassword: 'Nueva contraseña',
    confirmPassword: 'Confirmar nueva contraseña',
    pwUpdate: 'Actualizar contraseña',
    pwUpdating: 'Actualizando…',
    pwMismatch: 'Las nuevas contraseñas no coinciden',
    pwTooShort: 'La nueva contraseña debe tener al menos 8 caracteres',
    pwUpdated: 'Contraseña actualizada',
    pwError: 'Error al cambiar la contraseña',
    forgotTitle: '¿Olvidaste tu contraseña?',
    forgotDesc: 'Recibe un enlace por email para restablecer tu contraseña.',
    forgotCta: 'Restablecer contraseña →',
    suspendedOk: 'Reservas suspendidas',
    reactivatedOk: 'Reservas reactivadas',
    section: {
      company: 'Datos de la empresa',
      address: 'Domicilio social',
      personal: 'Datos personales',
      payout: 'Datos de cobro',
      presentation: 'Presentación',
      documents: 'Documentos de la empresa',
      season: 'Temporada de reservas',
      account: 'Cuenta y seguridad',
    },
    field: {
      company_name: 'Razón social',
      company_vat: 'NIF/CIF',
      company_pec: 'Correo certificado (PEC)',
      company_sdi: 'Código SDI',
      vendor_phone: 'Teléfono',
      address_street: 'Dirección',
      address_city: 'Ciudad',
      address_province: 'Provincia',
      address_postal_code: 'Código postal',
      payout_iban: 'IBAN',
      payout_holder: 'Titular de la cuenta',
      vendor_bio: 'Bio / descripción',
      email_verified: 'Email verificado',
      name: 'Nombre',
      email: 'Email',
      BUSINESS_REGISTRATION: 'Registro mercantil',
      VAT_CERTIFICATE: 'Certificado de NIF/CIF',
      INSURANCE: 'Seguro de responsabilidad civil',
    },
  },

  // BOOKING SUSPENDED OVERLAY
  // ============================================
  suspended: {
    title: 'Reservas temporalmente suspendidas',
    description: 'Estamos actualizando nuestro sistema de reservas. Déjanos tu email y te avisaremos en cuanto puedas volver a reservar.',
    notifyLabel: '¿Quieres que te avisemos?',
    emailPlaceholder: 'Tu email',
    notifyBtn: 'Avísame cuando esté disponible',
    sending: 'Enviando...',
    error: 'Se ha producido un error. Inténtalo de nuevo.',
    vendorTitle: 'Reservas de partner suspendidas',
    vendorDescription: 'Este partner ha suspendido temporalmente las reservas de sus barcos.',
    boatTitle: 'Reservas de barco suspendidas',
    boatDescription: 'Las reservas de este barco están temporalmente suspendidas.',
    suspendVendorBookings: 'Suspender reservas del partner',
    unsuspendVendorBookings: 'Reanudar reservas del partner',
    suspendVendorBookingsDesc: 'Bloquea las reservas de todos los barcos de este partner.',
    suspendMyBookings: 'Pausar mis reservas',
    unsuspendMyBookings: 'Reanudar mis reservas',
    suspendMyBookingsDesc: 'Pausa las reservas de todos tus barcos (p. ej. periodo de vacaciones).',
    suspendBoatBookings: 'Suspender reservas',
    unsuspendBoatBookings: 'Reanudar reservas',
    byAdmin: 'Suspendido por el administrador',
  },

  // ============================================
  // COOKIE CONSENT
  // ============================================
  cookie: {
    title: 'Privacidad a Bordo',
    description: 'Utilizamos cookies para ofrecerte una experiencia de navegación óptima y personalizar tus próximos itinerarios en Cerdeña.',
    acceptAll: 'Aceptar Todo',
    decline: 'Rechazar',
    advancedPrefs: 'Preferencias Avanzadas',
    savePrefs: 'Guardar Preferencias',
    alwaysActive: 'siempre activas',
    necessary: 'Necesarias',
    necessaryDesc: 'Cookies esenciales para el funcionamiento del sitio web. No se pueden desactivar.',
    analytics: 'Analíticas',
    analyticsDesc: 'Nos ayudan a entender cómo usas el sitio para mejorar tu experiencia.',
    marketing: 'Marketing',
    marketingDesc: 'Se utilizan para mostrarte ofertas y promociones relevantes.',
    preferences: 'Preferencias',
    preferencesDesc: 'Recuerdan tus elecciones, como el idioma y la zona de navegación.',
  },

  // ============================================
  // AUTH - REGISTER
  // ============================================
  register: {
    title: 'Crear Cuenta',
    subtitle: 'Empieza tu aventura en el mar',
    nameLabel: 'Nombre Completo',
    namePlaceholder: 'Juan Pérez',
    emailLabel: 'Email',
    emailPlaceholder: 'tu@email.com',
    passwordLabel: 'Contraseña',
    passwordPlaceholder: '••••••••',
    passwordHelper: 'Mín. 8 caracteres, mayúscula, minúscula, número, carácter especial',
    confirmPasswordLabel: 'Confirmar Contraseña',
    passwordMismatch: 'Las contraseñas no coinciden',
    submitButton: 'Regístrate',
    submittingButton: 'Registrando...',
    hasAccount: '¿Ya tienes una cuenta? Inicia sesión',
    // Role selection
    roleLabel: 'Tipo de cuenta',
    roleGuest: 'Turista',
    roleGuestDesc: 'Reserva barcos y servicios',
    roleVendor: 'Propietario',
    roleVendorDesc: 'Pon tu barco en alquiler',
    roleAgency: 'Agencia',
    roleAgencyDesc: 'Revende barcos y servicios de las empresas',
    roleCompany: 'Empresa',
    roleCompanyDesc: 'Gestiona una flota de barcos',
    roleServiceProvider: 'Proveedor de Servicios',
    roleServiceProviderDesc: 'Ofrece servicios a barcos y clientes',
    roleServiceProviderDisabled: 'Solo por invitación',
    roleExcursion: 'Operador de Excursiones',
    roleExcursionDesc: 'Snorkel, tours, senderismo — solo excursiones',
    providesExcursionsLabel: 'También ofrezco excursiones guiadas',
    providesExcursionsHelp: 'Marca esta opción si tu empresa hace tanto charter como excursiones: tendrás acceso a ambos paneles.',
    companyTypeTitle: '¿A qué se dedica tu empresa?',
    companyTypeSubtitle: 'Elige el tipo de actividad para habilitar las funciones adecuadas',
    serviceTypeTitle: '¿Qué ofreces?',
    serviceTypeSubtitle: 'Elige todos los servicios que ofreces (puedes seleccionar más de uno)',
    art49Title: 'Eres un particular: alquiler ocasional (art. 49-bis)',
    art49Intro: 'Como particular sin NIF/CIF puedes alquilar o fletar tu barco de forma ocasional. Puntos clave:',
    art49P1: 'Hasta 42 días al año en total (alquiler, excursiones y experiencias).',
    art49P2: 'Régimen fiscal favorable: impuesto sustitutivo del 20% sobre los ingresos (bajo petición).',
    art49P3: 'No constituye el ejercicio de una actividad comercial.',
    art49P4: 'Superado el límite se requiere el NIF/CIF: deberás registrarte como Empresa.',
    art49Disclaimer: 'Referencia: art. 49-bis del Código de Navegación de Recreo italiano (Decreto Legislativo 171/2005). Información orientativa, no asesoramiento fiscal.',
    vatLookupCta: 'Obtener datos por NIF/CIF',
    vatSearching: 'Buscando…',
    vatAutofilled: 'Datos autocompletados — revisa y corrige si es necesario',
    vatEnterFirst: 'Introduce primero el NIF/CIF',
    vatInvalid: 'NIF/CIF no válido',
    vatError: 'Error al obtener los datos',
    vatNetworkError: 'Error de red',
    vatLookupHint: 'Introduce el NIF/CIF y pulsa "Buscar" para autocompletar la razón social, el PEC y la dirección (después podrás editarlos).',
    companyTypeCharter: 'Charter / Alquiler de barcos',
    companyTypeCharterDesc: 'Gestiona una flota de barcos de alquiler',
    companyTypeExcursion: 'Solo excursiones',
    companyTypeExcursionDesc: 'Snorkel, tours guiados, senderismo, degustaciones — sin alquiler',
    companyTypeMixed: 'Charter + excursiones',
    companyTypeMixedDesc: 'Ofreces ambos: tendrás acceso a los dos paneles desde la misma área de partner',
    serviceProviderSectionTitle: 'Información del Proveedor',
    vendorSectionTitle: 'Información del Propietario',
    vendorPhoneLabel: 'Teléfono',
    vendorPhonePlaceholder: '+34 600 000 000',
    companySectionTitle: 'Datos de la Empresa',
    companyNameLabel: 'Razón Social',
    companyNamePlaceholder: 'Nombre Empresa S.L.',
    companyVatLabel: 'NIF/CIF',
    companyVatPlaceholder: 'ESB12345678',
    companyPecLabel: 'PEC',
    companySdiLabel: 'Código SDI',
    spSectionTitle: 'Información del Proveedor',
    spLicenseLabel: 'Número de Licencia',
    spLicensePlaceholder: 'p. ej. ABC-12345',
    spServiceAreaLabel: 'Área de servicio',
    spServiceAreaPlaceholder: 'p. ej. Alghero, Sassari...',
    spFleetSizeLabel: 'Número de vehículos',
    passwordStrengthWeak: 'Débil',
    passwordStrengthFair: 'Aceptable',
    passwordStrengthGood: 'Buena',
    passwordStrengthStrong: 'Fuerte',
    pendingApprovalInfo: 'Este tipo de cuenta requiere la aprobación del equipo.',
    pendingApprovalTitle: 'Registro Enviado',
    pendingApprovalMessage: 'Tu cuenta se ha creado correctamente. Nuestro equipo verificará tus datos y aprobará tu perfil.',
    pendingApprovalStep1: '1. Cuenta creada correctamente',
    pendingApprovalStep2: '2. Esperando verificación del equipo',
    pendingApprovalStep3: '3. Recibirás una notificación por email',
    backToHome: 'Volver al inicio',
  },

  // ============================================
  // MAINTENANCE PAGE
  // ============================================
  maintenance: {
    title: 'Sitio en Mantenimiento',
    message: 'Estamos actualizando el sitio para ofrecerte una experiencia mejor. Volveremos a estar en línea en breve.',
    footer: 'InsulaCharter - Alquiler de Barcos en Cerdeña',
  },

  // ============================================
  // LANDING PAGE (Pre-launch)
  // ============================================
  landing: {
    title: 'InsulaCharter',
    subtitle: 'Estamos trabajando para ti',
    message1: 'Nuestro nuevo sitio está en fase de desarrollo.',
    message2: 'Pronto podrás descubrir los mejores barcos de alquiler en Cerdeña.',
    needInfo: '¿Necesitas información?',
    devAccess: 'Acceso de desarrollador',
    devLoginTitle: 'Acceso de Desarrollador',
    devLoginMessage: 'Introduce la contraseña para acceder al sitio',
    wrongPassword: 'Contraseña incorrecta',
    copyright: '© 2026 InsulaCharter - Alquiler de Barcos en Cerdeña',
  },

  // ============================================
  // TOAST MESSAGES
  // ============================================
  toast: {
    bookingCreated: '¡Reserva creada correctamente!',
    bookingCancelled: '¡Reserva cancelada correctamente!',
    bookingError: 'Error al crear la reserva: ',
    boatCreated: '¡Barco añadido correctamente!',
    boatUpdated: '¡Barco actualizado correctamente!',
    boatDeleted: '¡Barco eliminado correctamente!',
    maxPhotos: 'Puedes añadir un máximo de 10 fotos',
    nameMinLength: 'El nombre debe tener al menos 3 caracteres',
    descriptionMinLength: 'La descripción debe tener al menos 10 caracteres',
    serviceExists: 'Ya existe un servicio con este nombre',
  },

  // ============================================
  // CONFIRM DIALOGS
  // ============================================
  confirm: {
    cancelBooking: '¿Quieres cancelar la reserva?',
    deleteBoat: '¿Seguro que quieres eliminar este barco de la flota de InsulaCharter?',
    deleteServiceUsed: 'Este servicio se utiliza en {count} barcos. ¿Quieres eliminarlo de todos modos?',
    deleteService: '¿Quieres eliminar este servicio?',
  },

  // ============================================
  // LANGUAGE SELECTOR
  // ============================================
  language: {
    select: 'Idioma',
    it: 'Italiano',
    en: 'Inglés',
    de: 'Alemán',
  },

  // ============================================
  // CALENDAR
  // ============================================
  calendar: {
    available: 'Disponible',
    booked: 'Reservado',
    pending: 'Pendiente',
    blocked: 'No disponible',
    yourSelection: 'Tu selección',
    selectDates: 'Selecciona las fechas',
    pickupDate: 'Recogida',
    returnDate: 'Devolución',
    days: 'días',
    day: 'día',
    clearSelection: 'Borrar selección',
    confirmDates: 'Confirmar fechas',
    availability: 'Disponibilidad',
    selectPickup: 'Selecciona la fecha de recogida',
    selectReturn: 'Selecciona la fecha de devolución',
    // Booking detail modal
    bookingDetails: 'Detalles de la Reserva',
    boat: 'Barco',
    client: 'Cliente',
    period: 'Periodo',
    passengers: 'pasajeros',
    total: 'Total',
    basePrice: 'Alquiler',
    insuranceFee: 'Seguro',
    extras: 'Extras',
    specialRequests: 'Solicitudes especiales',
    createdAt: 'Creada el',
    unavailable: 'No disponible',
    paymentMethod: 'Método de Pago',
  },

  // ============================================
  // ICAL SYNC
  // ============================================
  ical: {
    title: 'Sincronización iCal',
    titleWithBoat: 'Sincronización iCal — {boatName}',
    exportUrl: 'URL de Exportación',
    exportHint: 'Usa esta URL para importar el calendario en otras plataformas (Airbnb, Booking.com, MMK Booking Manager, etc.)',
    importedFeeds: 'Feeds Importados',
    addFeed: 'Añadir Feed',
    feedUrlPlaceholder: 'URL del feed iCal',
    feedLabelPlaceholder: 'Etiqueta (opcional)',
    cancel: 'Cancelar',
    adding: 'Añadiendo...',
    add: 'Añadir',
    noFeeds: 'No hay feeds importados',
    events: 'eventos',
    error: 'Error',
    lastSync: 'Última sincronización',
    confirmDelete: '¿Eliminar este feed iCal?',
    syncNow: 'Sincronizar ahora',
    openFeed: 'Abrir feed',
    deleteFeed: 'Eliminar feed',
    sourceAirbnb: 'Airbnb',
    sourceBooking: 'Booking.com',
    sourceGoogle: 'Google Calendar',
    sourceMmk: 'MMK Booking Manager',
    sourceOther: 'Otro',
    guideTitle: 'Cómo conectar tu calendario externo',
    guideStep1: '1. Copia la URL de exportación de arriba y pégala en la plataforma externa (MMK, Airbnb, etc.) como "calendario externo" o "feed iCal"',
    guideStep2: '2. En la plataforma externa, copia la URL del calendario de tu embarcación y pégala aquí abajo haciendo clic en "Añadir Feed"',
    guideStep3: '3. La sincronización se realiza automáticamente cada 15 minutos. Puedes forzarla con el botón "Sincronizar ahora"',
    boatsTitle: 'Embarcaciones de alquiler',
    excursionsTitle: 'Excursiones y experiencias',
    excursionsHint: 'Publica las salidas de tus excursiones/experiencias en calendarios externos (solo exportación).',
    excursionsEmpty: 'No hay excursiones ni experiencias',
    copyExportUrl: 'Copiar',
    manageFeeds: 'Gestionar feeds',
  },

  // ============================================
  // BOOKING (Reservas)
  // ============================================
  booking: {
    bookingSuspensionToggled: 'Estado de suspensión de reservas actualizado',
    confirmed: 'Confirmada',
    pending: 'Pendiente',
    cancelled: 'Cancelada',
    completed: 'Completada',
    refunded: 'Reembolsada',
    awaitingPayment: 'Pendiente de pago',
    pendingLateBooking: 'Pendiente de confirmación',
    payNow: 'Pagar ahora',
    startingPayment: 'Iniciando…',
    paymentStartFailed: 'No se ha podido iniciar el pago. Inténtalo de nuevo.',
    networkErrorRetry: 'Error de red. Inténtalo de nuevo.',
    modify: 'Modificar',
    cancel: 'Cancelar',
    receipt: 'Recibo',
    paid: 'Pagado',
    notPaid: 'Sin pagar',
    partiallyPaid: 'Parcial',
    depositPaid: 'Fianza pagada',
    depositRefunded: 'Fianza reembolsada',
    paymentFailed: 'Fallido',
    departurePoint: 'Punto de salida',
    departurePointRequired: 'Selecciona un punto de salida',
    departureFrom: 'Salida desde',
  },

  // ============================================
  // CANCELLATION REQUEST (cliente-driven)
  // ============================================
  cancellation: {
    reasonBadWeather: 'Mal tiempo',
    reasonBadWeatherHint: 'Mar agitado, alerta oficial, condiciones no seguras',
    reasonHealth: 'Motivos de salud',
    reasonHealthHint: 'Enfermedad o lesión del titular de la reserva',
    reasonEmergency: 'Emergencia',
    reasonEmergencyHint: 'Imprevisto familiar o laboral grave',
    reasonForceMajeure: 'Fuerza mayor',
    reasonForceMajeureHint: 'Eventos incontrolables (p. ej. confinamientos, fallecimientos)',
    reasonOther: 'Otro motivo',
    reasonOtherHint: 'Especifica el motivo en la descripción',
    requestSentTitle: 'Solicitud de cancelación enviada',
    requestSentDesc: 'El vendor está evaluando tu solicitud. Recibirás una respuesta por email.',
    reasonLabel: 'Motivo:',
    rejectedTitle: 'Solicitud no aprobada',
    rejectedDefaultDesc: 'El vendor ha rechazado la solicitud de cancelación.',
    newRequest: 'Enviar una nueva solicitud',
    approvedTitle: 'Cancelación aprobada',
    approvedDesc: 'El posible reembolso se procesará según el método de pago original.',
    requestCta: 'Solicitar cancelación',
    formTitle: 'Solicitud de cancelación por causa justificada',
    formSubtitle: 'Selecciona un motivo. El vendor evaluará la solicitud y podrá aprobarla o rechazarla.',
    description: 'Descripción',
    descriptionPlaceholderOther: 'Explica el motivo de la solicitud (obligatorio para "Otro")',
    descriptionPlaceholderDefault: 'Añade detalles útiles para el vendor (opcional)',
    minChars: 'Mínimo 10 caracteres',
    cancel: 'Cancelar',
    sending: 'Enviando…',
    sendRequest: 'Enviar solicitud',
    sendFailed: 'Error al enviar',
    unknownError: 'Error desconocido',
  },

  // ============================================
  // REVIEW FORM
  // ============================================
  review: {
    selectRating: 'Selecciona una valoración general.',
    writeComment: 'Escribe un comentario.',
    submitError: 'Error al enviar la reseña.',
    overallRating: 'Valoración general *',
    titleLabel: 'Título (opcional)',
    titlePlaceholder: 'Resume tu experiencia',
    commentLabel: 'Comentario *',
    commentPlaceholder: 'Cuéntanos tu experiencia...',
    detailedRatings: 'Valoraciones detalladas (opcionales)',
    boatCondition: 'Estado del barco',
    itinerary: 'Itinerario',
    valueForMoney: 'Relación calidad-precio',
    communication: 'Comunicación',
    sending: 'Enviando...',
    submit: 'Enviar reseña',
  },

  // ============================================
  // AMBASSADOR (banner + códigos de invitación)
  // ============================================
  ambassador: {
    requestSent: 'Solicitud enviada',
    genericError: 'Error',
    codeCopied: '¡Código copiado!',
    copyFailed: 'No se ha podido copiar',
    linkCopied: '¡Enlace copiado!',
    linkCopyFailed: 'No se ha podido copiar el enlace',
    youAreAmbassador: '¡Eres un Ambassador!',
    commissionPct: '{rate}% de comisión',
    copyCode: 'Copiar código',
    copyInviteLink: 'Copiar enlace de invitación',
    peopleReferred: 'personas referidas',
    viaCode: ' · {used} vía código',
    withYourCode: ' con tu código',
    generateLink: 'Generar enlace',
    pendingTitle: 'Solicitud de ambassador pendiente',
    pendingDesc: 'Nuestro equipo está evaluando tu solicitud',
    rejectedDesc: 'Tu solicitud de ambassador no ha sido aprobada.',
    becomeAmbassador: 'Conviértete en Ambassador',
    becomeAmbassadorDesc: 'Gana una comisión por cada usuario que traigas a la plataforma',
    sendingRequest: 'Enviando...',
    applyRequest: 'Solicitar ser Ambassador',
  },

  // ============================================
  // AMBASSADOR CODES MANAGER (multi-código + referidos)
  // ============================================
  ambassadorCodes: {
    roleCustomer: 'Cliente',
    roleAgency: 'Agencia',
    roleCollaborator: 'Colaborador',
    roleVendor: 'Vendor',
    roleCompany: 'Empresa',
    roleAdmin: 'Admin',
    roleServiceProvider: 'Proveedor',
    roleHost: 'Host',
    codeActivated: 'Código activado',
    codeDeactivated: 'Código desactivado',
    codeCreated: 'Código {code} creado',
    createError: 'Error al crear',
    loadingCodes: 'Cargando códigos...',
    myInviteCodes: 'Mis códigos de invitación',
    newCode: 'Nuevo código',
    deactivated: 'Desactivado',
    exhausted: 'Agotado',
    uses: 'usos',
    reactivate: 'Reactivar',
    deactivate: 'Desactivar',
    peopleBrought: 'Personas referidas',
    noPeopleYet: 'Todavía no has referido a nadie.',
    tableName: 'Nombre',
    tableType: 'Tipo',
    tableOrigin: 'Origen',
    tableDate: 'Fecha',
    manual: 'Manual',
    viaCodeOrigin: 'Código',
    newCodeModalTitle: 'Nuevo código de invitación',
    newCodeModalSubtitle: 'Crea un código para una campaña específica',
    creating: 'Creando...',
    createCode: 'Crear código',
    label: 'Etiqueta',
    optional: '(opcional)',
    labelPlaceholder: 'P. ej. Campaña verano 2026',
    labelHint: 'Solo para tu organización — no visible públicamente.',
    maxUses: 'Usos máximos',
    maxUsesPlaceholder: 'Ilimitado si se deja vacío',
    maxUsesHint: 'Cuántas veces se puede usar el código antes de agotarse.',
    commissionNote: 'La comisión se heredará de tu código principal. Solo un administrador puede modificar el porcentaje.',
  },

  // ============================================
  // PROFILE
  // ============================================
  profile: {
    // Page header
    myProfile: 'Mi Perfil',
    manageYourAccount: 'Gestiona tus datos personales, documentos y preferencias de pago',

    // Sections
    personalData: 'Datos Personales',
    address: 'Dirección de Residencia',
    phoneNumber: 'Número de Teléfono',
    documents: 'Documentos de Identidad',
    profilePhoto: 'Foto de Perfil',

    // Personal data fields
    firstName: 'Nombre',
    firstNamePlaceholder: 'Introduce tu nombre',
    lastName: 'Apellidos',
    lastNamePlaceholder: 'Introduce tus apellidos',
    dateOfBirth: 'Fecha de Nacimiento',
    nationality: 'Nacionalidad',
    nationalityPlaceholder: 'Selecciona tu nacionalidad',
    fiscalCode: 'Código Fiscal',
    fiscalCodePlaceholder: 'p. ej.: RSSMRA80A01H501U',
    fiscalCodeHelper: 'Opcional - Solo para ciudadanos italianos',

    // Address fields
    street: 'Calle/Dirección',
    streetPlaceholder: 'Calle Mayor, 123',
    city: 'Ciudad',
    cityPlaceholder: 'p. ej.: Olbia',
    postalCode: 'Código Postal',
    postalCodePlaceholder: 'p. ej.: 07026',
    province: 'Provincia/Estado',
    provincePlaceholder: 'p. ej.: SS',
    country: 'País',
    countryPlaceholder: 'Selecciona el país',

    // Phone fields
    mobilePhone: 'Teléfono Móvil',
    phoneHelper: 'Introduce solo números, sin espacios ni guiones',

    // Document fields
    documentType: 'Tipo de Documento',
    selectDocumentType: 'Selecciona el tipo de documento...',
    identityCard: 'DNI',
    passport: 'Pasaporte',
    drivingLicense: 'Carné de Conducir',
    boatLicense: 'Licencia Náutica',
    documentNumber: 'Número de Documento',
    documentNumberPlaceholder: 'p. ej.: AB1234567',
    documentExpiry: 'Fecha de Caducidad',
    frontImage: 'Imagen Frontal',
    backImage: 'Imagen Trasera (opcional)',
    clickToUpload: 'Haz clic para subir',
    addDocument: 'Añadir Documento',
    uploadDocument: 'Subir Documento',
    noDocuments: 'No hay documentos subidos',
    expiresOn: 'Caduca el',
    verified: 'Verificado',
    pending: 'Pendiente de verificación',
    confirmDeleteDocument: '¿Quieres eliminar este documento?',
    requiredFields: 'Rellena todos los campos obligatorios',
    documentTooLarge: 'El archivo es demasiado grande. Máximo 10MB.',

    // Avatar
    uploadPhoto: 'Subir Foto',
    deletePhoto: 'Eliminar',
    confirmDeleteAvatar: '¿Quieres eliminar la foto de perfil?',
    cropImage: 'Recortar Imagen',
    zoom: 'Zoom',
    rotate: 'Rotar',
    invalidImageType: 'Tipo de archivo no válido. Usa PNG, JPG o PDF.',
    imageTooLarge: 'La imagen es demasiado grande. Máximo 5MB.',

    // Email verification
    emailVerification: 'Verificación de Email',
    emailVerified: 'Email Verificado',
    emailNotVerified: 'Email no verificado',
    verify: 'Verificar',
    clickToVerify: 'Haz clic para verificar',
    resendVerification: 'Reenviar email de verificación',
    emailVerificationDescription: 'Verifica tu email para desbloquear todas las funciones de tu cuenta.',
    sendVerificationEmail: 'Enviar Email de Verificación',
    verificationEmailSent: '¡Email de verificación enviado! Revisa tu bandeja de entrada.',

    // User profile page
    loginToViewProfile: 'Inicia sesión para ver tu perfil.',
    myBookings: 'Reservas',
    noBookings: 'No hay reservas',
    unknownBoat: 'Barco desconocido',
    guest: 'Invitado',
    memberSince: 'Miembro desde',
    bookingDetails: 'Detalles de la Reserva',
    embarkationPoint: 'Punto de Embarque',
    length: 'Eslora',
    maxCapacity: 'Capacidad Máxima',
    bookingStatus: 'Estado de la Reserva',
    totalPaid: 'Total Pagado',
    contactSkipper: 'Contactar con el Patrón',

    downloadReceipt: 'Descargar Recibo',

    // Success/Error messages
    updateSuccess: '¡Perfil actualizado correctamente!',

    // Profile save (customer form)
    profileUpdated: 'Perfil actualizado',
    saveError: 'Error al guardar',
    saving: 'Guardando…',
    saveProfile: 'Guardar perfil',

    // Tab sections
    documentsTitle: 'Documentos',
    documentsSubtitle: 'Sube tu documento de identidad y licencia náutica',
    paymentMethodsSubtitle: 'Tarjetas y métodos guardados',
    savedBoats: 'Los barcos que has guardado',
    ambassadorTab: 'Ambassador',
    ambassadorProgram: 'Programa Ambassador',
    ambassadorProgramDesc: 'Invita a amigos y gana comisiones por los alquileres',

    // Stats hero
    upcoming: 'Próximas',
    total: 'Totales',
    nextDeparture: 'Próxima salida',
    today: 'Hoy',
    tomorrow: 'Mañana',
    inDays: 'En {n} días',
    bookingDetailsCta: 'Detalles de la reserva',

    // Bookings list
    bookingSentSuccess: 'Reserva enviada correctamente',
    bookingSentSuccessDesc: 'Recibirás un email de confirmación en cuanto el propietario apruebe la solicitud.',
    noBookingsYet: 'Todavía no hay reservas',
    noBookingsDesc: 'Busca un barco y reserva tu primera experiencia en el mar.',
    searchBoat: 'Buscar un barco',
    boatsSection: 'Barcos',
    experiencesSection: 'Experiencias',
    experienceFallback: 'Experiencia',
    awaitingOperator: 'Pendiente de confirmación del operador',
    reviewed: 'Reseñado',
    leaveReview: 'Dejar una reseña',
    reviewSubmittedPending: 'Reseña enviada, pendiente de aprobación.',
    leaveReviewModalTitle: 'Deja una reseña',
    leaveReviewModalSubtitle: 'Tu opinión ayuda a otros viajeros',
    checkIn: 'Check-in',
    checkOut: 'Check-out',
    bookingCountOne: '{count} reserva',
    bookingCountOther: '{count} reservas',
    notSet: 'No definido',
    exampleCityPlaceholder: 'P. ej.: Olbia',
    exampleVatPlaceholder: 'P. ej.: 01692360918',
  },

  // ============================================
  // FAVORITES
  // ============================================
  favorites: {
    title: 'Favoritos',
    empty: 'No hay favoritos guardados',
    emptyHint: 'Toca el corazón en los barcos para guardarlos aquí.',
    remove: 'Quitar de favoritos',
    added: 'Añadido a favoritos',
    removed: 'Eliminado de favoritos',
  },

  // ============================================
  // PAYMENTS
  // ============================================
  payments: {
    paymentMethods: 'Métodos de Pago',
    addMethod: 'Añadir Método',
    noMethods: 'No hay métodos de pago guardados',
    addFirstMethod: 'Añade tu primer método de pago',
    selectType: 'Selecciona el tipo de pago',
    creditCard: 'Tarjeta de Crédito',
    bankTransfer: 'Transferencia Bancaria',
    cash: 'Efectivo',
    default: 'Predeterminado',
    setAsDefault: 'Establecer como predeterminado',
    confirmDelete: '¿Quieres eliminar este método de pago?',

    // Credit Card
    cardNumber: 'Número de Tarjeta',
    cardHolder: 'Titular de la Tarjeta',
    expiryDate: 'Fecha de Caducidad',
    expires: 'Caduca',
    cardSecurityNote: 'Por tu seguridad, no almacenamos el número completo de la tarjeta ni el CVV.',

    // PayPal
    paypalEmail: 'Email de PayPal',

    // IBAN
    accountHolder: 'Titular de la Cuenta',
    bankName: 'Nombre del Banco',

    // Common
    label: 'Etiqueta',
    labelPlaceholder: 'p. ej.: Tarjeta personal, Cuenta de empresa',
    optional: 'Opcional',
  },

  // ============================================
  // EQUIPMENT (Equipamiento a Bordo)
  // ============================================
  equipment: {
    gps: { label: 'GPS Chartplotter', description: 'Sistema de navegación GPS con cartografía marina' },
    vhf: { label: 'Radio VHF', description: 'Radio marina para comunicaciones de emergencia' },
    anchor: { label: 'Ancla con Cadena', description: 'Ancla completa con cadena y cabo' },
    lifejackets: { label: 'Chalecos Salvavidas', description: 'Chalecos salvavidas para todos los pasajeros' },
    bimini: { label: 'Toldo Bimini', description: 'Toldo parasol para protección solar' },
    shower: { label: 'Ducha de Popa', description: 'Ducha de agua dulce en popa' },
    cooler: { label: 'Nevera Portátil', description: 'Nevera portátil para bebidas y comida' },
    bluetooth: { label: 'Equipo de Sonido Bluetooth', description: 'Sistema de audio con conexión Bluetooth' },
    ladder: { label: 'Escalerilla de Baño', description: 'Escalerilla retráctil para fácil acceso al mar' },
    cushions: { label: 'Cojines para Tomar el Sol', description: 'Cojines acolchados para relajarse al sol' },
  },

  // ============================================
  // EXTRAS (Servicios Extra)
  // ============================================
  extras: {
    skipper: { label: 'Patrón Profesional', description: 'Capitán experto para la navegación' },
    hostess: { label: 'Azafata a Bordo', description: 'Asistencia y servicio a bordo' },
    fuel: { label: 'Depósito Lleno', description: 'Depósito lleno incluido en el precio' },
    snorkeling: { label: 'Kit de Snorkel', description: 'Máscara, tubo y aletas' },
    sup: { label: 'Stand Up Paddle', description: 'Tabla de SUP con remo' },
    towable: { label: 'Flotador Remolcable', description: 'Hinchable remolcable para divertirse' },
  },

  // ============================================
  // EXCURSION OPERATOR DASHBOARD
  // ============================================
  excursion: {
    dashboard: 'Panel de Excursiones',
    dashboardTitle: 'Panel de Excursiones',
    dashboardTitleCompany: 'Panel del Operador',
    dashboardSubtitle: 'Gestiona catálogo, horarios y reservas',
    menuMain: 'Principal',
    menuFleet: 'Catálogo',
    menuOperations: 'Operaciones',
    menuFinance: 'Finanzas',
    menuSettings: 'Configuración',
    fleet: 'Catálogo de excursiones',
    calendar: 'Calendario',
    availability: 'Disponibilidad',
    pricing: 'Precios',
    extras: 'Extras',
    bookings: 'Reservas',
    requests: 'Solicitudes especiales',
    customRequests: 'Solicitudes',
    clients: 'Clientes',
    reviews: 'Reseñas',
    coupons: 'Cupones',
    team: 'Equipo',
    earnings: 'Ganancias',
    earningsByChannel: 'Ganancias por canal',
    reports: 'Informes',
    notifications: 'Notificaciones',
    profile: 'Perfil',
    settings: 'Configuración',
    guide: 'Guía del operador',
    roleCompany: 'Empresa',
    roleVendor: 'Operador',
  },
  partner: {
    menuServices: 'Servicios',
    locazione: 'Alquiler',
    escursioni: 'Excursiones',
    esperienze: 'Experiencias',
    disponibilita: 'Disponibilidad',
    calendarioPartenze: 'Calendario de salidas',
  },

  // ============================================
  // EXCURSION FLOW — versión pública (modal, magic-link, catálogo V2)
  // ============================================
  customRequests: {
    title: 'Solicitudes de presupuesto',
    subtitle: 'Solicitudes de precio a medida de los clientes',
    refresh: 'Actualizar',
    filterActionable: 'Por gestionar',
    filterAll: 'Todas',
    empty: 'Todavía no hay solicitudes de presupuesto.',
    deletedExcursion: 'Experiencia eliminada',
    status: {
      PENDING: 'Nueva',
      VENDOR_PROPOSED: 'Propuesta enviada',
      CUSTOMER_COUNTER: 'Contraoferta del cliente',
      ACCEPTED: 'Aceptada',
      REJECTED: 'Rechazada',
      EXPIRED: 'Caducada',
      CONVERTED: 'Reservada',
    },
    drawerTitle: 'Detalle de la solicitud',
    noActivity: 'Todavía no hay actividad.',
    you: 'Tú',
    customer: 'Cliente',
    validUntil: 'Válida hasta',
    slotStart: 'Inicio',
    slotEnd: 'Fin',
    sendProposal: 'Enviar propuesta',
    proposalSent: 'Propuesta enviada al cliente.',
    priceInvalid: 'Introduce un precio válido.',
    pricePlaceholder: 'Precio €',
    notesPlaceholder: 'Notas para el cliente (opcional)',
    messagePlaceholder: 'Escribe un mensaje…',
    reject: 'Rechazar solicitud',
    rejected: 'Solicitud rechazada.',
    rejectReasonPlaceholder: 'Motivo (opcional)',
    confirmReject: 'Confirmar rechazo',
  },
  myRequests: {
    title: 'Mis solicitudes',
    subtitle: 'Presupuestos solicitados y propuestas recibidas',
    back: 'Volver a las solicitudes',
    empty: 'Todavía no tienes solicitudes de presupuesto.',
    deletedExcursion: 'Experiencia eliminada',
    status: {
      PENDING: 'Esperando respuesta',
      VENDOR_PROPOSED: 'Propuesta recibida',
      CUSTOMER_COUNTER: 'Contraoferta enviada',
      ACCEPTED: 'Aceptada',
      REJECTED: 'Rechazada',
      EXPIRED: 'Caducada',
      CONVERTED: 'Reservada',
    },
  },
  excursionFlow: {
    catalogKicker: 'Cerdeña · experiencias',
    catalogTitlePart1: 'Lo que',
    catalogTitleAccent: 'la isla',
    catalogTitlePart2: 'nunca te cuenta en las guías.',
    catalogSubtitle: 'Itinerarios guiados y actividades seleccionadas por operadores locales — del senderismo a los tours en barco, del snorkel a las catas.',
    catalogCounterLabel: 'Experiencias activas',
    catalogFilterAll: 'Todas',
    catalogEmptyTitle: 'Estamos preparando las próximas experiencias.',
    catalogEmptyBody: 'Las excursiones de la próxima temporada se publicarán en breve. Mientras tanto, puedes explorar los barcos disponibles para alquilar.',
    catalogEmptyCta: 'Ver barcos',
    catalogEmptyFilterTitle: 'No hay ninguna excursión en esta categoría.',
    catalogEmptyFilterBody: 'Prueba a quitar el filtro para ver todas las experiencias.',
    catalogEmptyFilterCta: 'Ver todas',

    cardDiscover: 'Descubrir',
    cardFeaturedBadge: 'Destacada',
    cardOnRequest: 'Bajo petición',
    cardFrom: 'Desde',
    cardPerPerson: 'por persona',
    cardPerGroup: 'por grupo',
    cardMaxPeople: 'máx.',

    specialRequestCta: 'Haz una solicitud especial',
    modalTitle: 'Solicitud especial',
    modalTypeLabel: 'Tipo de solicitud',
    typeTimeCustomLabel: 'Horario personalizado',
    typeTimeCustomDesc: 'El mismo tour, con un horario de salida diferente',
    typeGroupCustomLabel: 'Grupo no estándar',
    typeGroupCustomDesc: 'Número de personas fuera de la capacidad estándar',
    typePrivateLabel: 'Tour privado',
    typePrivateDesc: 'Solo vosotros, sin otros participantes',
    typeFullyCustomLabel: 'Experiencia totalmente a medida',
    typeFullyCustomDesc: 'Itinerario, duración o contenido diferentes',
    fieldDateStart: 'Fecha preferida',
    fieldDateEnd: 'Fecha de fin (si son varios días)',
    fieldPeople: 'Personas',
    fieldMessage: 'Mensaje para el operador',
    fieldMessagePlaceholder: 'P. ej. Nos gustaría salir a las 16:00 en lugar del horario estándar, somos una familia con 2 niños de 8 y 10 años…',
    fieldContactsHeading: 'Tus datos de contacto',
    fieldName: 'Nombre y apellidos',
    fieldEmail: 'Email',
    fieldPhone: 'Teléfono (opcional)',
    btnCancel: 'Cancelar',
    btnSendRequest: 'Enviar solicitud',
    successTitle: 'Solicitud enviada',
    successBody: 'Nuestro operador recibirá una notificación y te responderá por email a {email} con una propuesta personalizada. Revisa también la carpeta de spam.',
    successCta: 'Entendido',
    disclaimer: 'Recibirás una respuesta por email en pocas horas. La solicitud no supone ningún compromiso: podrás aceptar o rechazar la propuesta final del operador.',

    magicHeroKicker: 'Solicitud especial',
    magicHeroGreeting: 'Hola {name}, aquí tienes la propuesta de nuestro operador.',
    magicProposalLabel: 'Propuesta del vendor',
    magicProposalTotal: 'total',
    magicProposalWhen: 'Fecha/hora',
    magicProposalValidUntil: 'Válida hasta',
    magicProposalNotes: 'Detalles',
    magicAcceptCta: 'Aceptar y pagar',
    magicRejectCta: 'Rechazar',
    magicCounterCta: 'Hacer contraoferta',
    magicCounterTitle: 'Contraoferta',
    magicCounterSubmit: 'Enviar',
    magicAcceptConfirm: '¿Confirmas que quieres aceptar la propuesta? Serás redirigido al pago.',
    magicRejectPrompt: 'Motivo (opcional, visible para el vendor):',
    magicRejectConfirm: '¿Confirmas el rechazo?',
    magicLinkExpiredTitle: 'Enlace no válido',
    magicLinkExpiredBody: 'Solicitud no encontrada o enlace caducado',
    magicMyRequest: 'Tu solicitud',
    magicConversation: 'Conversación',
    magicMsgPlaceholder: 'Escribe al vendor…',
    magicValidUntilFooter: 'Enlace válido hasta el {date}.',
    magicCreateAccount: 'Crea una cuenta',
    magicCreateAccountSuffix: 'para gestionar todas tus solicitudes.',
    magicStatusAccepted: 'Propuesta aceptada. Continúa con el pago para confirmar.',
    magicStatusConverted: 'Pago completado. Tu excursión está confirmada.',
    magicStatusRejected: 'Propuesta rechazada.',
    magicStatusExpired: 'Solicitud caducada.',
  },

  // ============================================
  // VENDOR DASHBOARD
  // ============================================
  vendor: {
    earningsByChannel: 'Ganancias por canal',
    // Dashboard
    dashboard: 'Panel',
    dashboardTitle: 'Panel del Vendor',
    dashboardTitleCompany: 'Panel de la Empresa',
    dashboardSubtitle: 'Gestiona tus barcos y reservas',

    // Sidebar menu groups
    menuMain: 'Principal',
    menuFleet: 'Flota',
    menuOperations: 'Operaciones',
    menuFinance: 'Finanzas',
    menuSettings: 'Configuración',
    // Sidebar menu items
    fleet: 'Barcos',
    pricing: 'Precios',
    bulk: 'Operaciones masivas',
    suspensions: 'Suspensiones',
    extras: 'Servicios Extra',
    bookings: 'Reservas',
    customRequests: 'Solicitudes',
    clients: 'Clientes',
    reviews: 'Reseñas',
    coupons: 'Cupones',
    team: 'Equipo',
    network: 'Red y Partners',
    earnings: 'Ganancias',
    reports: 'Informes',
    analytics: 'Analítica',
    notifications: 'Notificaciones',
    profile: 'Perfil',
    settings: 'Configuración',
    guide: 'Guía',
    roleVendor: 'Armador',
    roleCompany: 'Empresa',

    // Navigation (legacy)
    myBoats: 'Mis barcos',
    myBookings: 'Reservas recibidas',
    myEarnings: 'Ganancias',
    myClients: 'Mis clientes',
    myExtras: 'Servicios Extra',
    myProfile: 'Perfil del Vendor',
    calendar: 'Calendario',

    // Tabs
    tabDashboard: 'Panel',
    tabMyBoats: 'Mis barcos',
    tabCalendar: 'Calendario',
    tabBookings: 'Reservas',
    tabEarnings: 'Ganancias',
    tabClients: 'Clientes',
    tabProfile: 'Perfil',
    tabCompanyProfile: 'Datos de la empresa',

    // Stats
    activeBoats: 'Barcos activos',
    totalBookings: 'Reservas',
    totalRevenue: 'Ingresos Totales',
    totalPayout: 'Pago Neto',
    platformFees: 'Comisiones de la Plataforma',
    bookingCount: 'Reservas',
    netEarnings: 'Ganancias netas',
    pendingPayout: 'Pago pendiente',
    paidOut: 'Ya pagado',
    occupancyRate: 'Tasa de Ocupación',
    revenuePerBoat: 'Ingreso Medio/Barco',
    loadingStats: 'Cargando estadísticas...',
    commissionUpdated: 'Comisión actualizada',

    // Boat List
    loadingBoats: 'Cargando barcos...',
    noBoats: 'No hay barcos',
    noBoatsHint: 'Añade tu primer barco desde el panel de administración',
    boatsCount: 'barcos',
    boatActive: 'Activo',
    boatInactive: 'Inactivo',
    approvalApproved: 'Aprobado',
    approvalPending: 'En revisión',
    approvalRejected: 'Rechazado',
    approvalNotes: 'Notas:',
    loadBoatsError: 'Error al cargar los barcos',

    // Calendar
    calendarTitle: 'Calendario de Reservas',
    calendarSubtitle: 'Consulta y gestiona las reservas de tus barcos',
    loadingCalendar: 'Cargando calendario...',
    noBoatsCalendar: 'Añade un barco para ver el calendario',
    allBoats: 'Todos los barcos',
    blockDates: 'Bloquear fechas',
    blockDatesTitle: 'Bloquear fechas',
    blockingFor: 'Bloqueo para',
    startDate: 'Fecha de inicio',
    endDate: 'Fecha de fin',
    blockReason: 'Motivo (opcional)',
    blockReasonPlaceholder: 'P. ej.: mantenimiento, uso personal...',
    blockWarning: 'Las fechas bloqueadas impedirán nuevas reservas para el periodo seleccionado',
    confirmBlock: 'Confirmar bloqueo',
    datesBlocked: 'Fechas bloqueadas correctamente',
    datesUnblocked: 'Fechas desbloqueadas',
    blockError: 'Error al bloquear las fechas',
    unblockError: 'Error al desbloquear las fechas',
    selectBoatFirst: 'Selecciona primero un barco',
    selectDatesFirst: 'Selecciona las fechas a bloquear',
    blockedPeriods: 'Periodos bloqueados',
    unblock: 'Desbloquear',
    fleetOverview: 'Resumen de la flota',
    confirmed: 'confirmadas',
    pendingLabel: 'pendientes',
    blocked: 'bloqueadas',
    noBookingsYet: 'No hay reservas',
    calendarLoadError: 'Error al cargar los datos del calendario',

    // Bookings
    loadingBookings: 'Cargando reservas...',
    allStatuses: 'Todos los estados',
    pendingBookings: 'Pendientes',
    confirmedRevenue: 'Ingresos confirmados',
    bookingsTitle: 'Reservas',
    bookingsSubtitle: 'Gestiona las reservas',
    noBookingsFound: 'No se han encontrado reservas',
    allPaymentStatuses: 'Todos los pagos',
    paymentPending: 'Pendiente de pago',
    paymentPaid: 'Pagado',
    paymentPartial: 'Parcial',
    paymentRefunded: 'Reembolsado',
    calendarView: 'Calendario',
    listView: 'Lista',
    searchGuest: 'Buscar cliente...',
    downloadReceipt: 'Descargar recibo',
    reversibleBookings: 'Reservas Reversibles',
    reversibleBookingsSubtitle: 'Puedes restaurar el estado anterior',
    boatsOverview: 'Resumen de Barcos',
    cancelWithReason: 'Cancelar con motivo',
    cancelConfirmMessage: '¿Seguro que quieres cancelar esta reserva?',
    cancelReasonPlaceholder: 'Motivo de la cancelación (opcional)',
    bookingDetail: 'Detalle de la Reserva',
    guestInfo: 'Información del Cliente',
    boatInfo: 'Información del Barco',
    rentalDetails: 'Detalles del Alquiler',
    experienceDetails: 'Detalles de la Experiencia',
    priceSummary: 'Resumen del Precio',
    basePrice: 'Precio base',
    insuranceFee: 'Seguro',
    specialRequests: 'Solicitudes Especiales',
    cancellationReason: 'Motivo de Cancelación',
    reverse: 'Restaurar',
    undo: 'Deshacer',
    statusPending: 'Pendiente',
    statusConfirmed: 'Confirmada',
    statusCompleted: 'Completada',
    statusCancelled: 'Cancelada',
    noBookings: 'No hay reservas',
    boatFallback: 'Barco',
    guestFallback: 'Invitado',
    nights: 'noches',
    guests: 'huéspedes',
    netPayout: 'Neto:',
    loadBookingsError: 'Error al cargar las reservas',

    // Earnings
    loadingEarnings: 'Cargando ganancias...',
    platformCommission: 'Comisión de la plataforma',
    earningsDetail: 'Detalle de ganancias',
    headerBoat: 'Barco',
    headerDates: 'Fechas',
    headerTotal: 'Total',
    headerCommission: 'Comisión',
    headerNet: 'Neto',
    headerPayout: 'Pago',
    payoutPaid: 'Pagado',
    payoutPending: 'Pendiente',

    // Client Management
    searchClient: 'Buscar cliente...',
    noClients: 'No hay clientes',
    noClientsHint: 'Los clientes aparecerán aquí después de la primera reserva',
    bookingsLabel: 'Reservas',
    spentLabel: 'Gastado',
    loadClientsError: 'Error al cargar los clientes',

    // Vendor Profile
    profileTitle: 'Perfil del Vendor',
    profileUpdated: 'Perfil actualizado correctamente',
    firstName: 'Nombre',
    firstNamePlaceholder: 'Juan',
    lastName: 'Apellidos',
    lastNamePlaceholder: 'Pérez',
    phone: 'Teléfono',
    phonePlaceholder: '+34 600 123 456',
    bio: 'Bio',
    bioPlaceholder: 'Preséntate a tus clientes...',
    vendorBio: 'Bio / Descripción',
    vendorPhone: 'Teléfono',
    payoutData: 'Datos de Cobro',
    iban: 'IBAN',
    ibanPlaceholder: 'ES91 2100 0418 4502 0005 1332',
    payoutIban: 'IBAN de Cobro',
    accountHolder: 'Titular de la cuenta',
    accountHolderPlaceholder: 'Juan Pérez',
    payoutHolder: 'Titular',
    saveProfile: 'Guardar perfil',
    loadProfileError: 'Error al cargar el perfil',
    saveProfileError: 'Error al guardar',

    // Company Profile
    companyData: 'Datos de la Empresa',
    companyName: 'Razón social',
    companyNamePlaceholder: 'Sardinia Charter S.L.',
    vatNumber: 'NIF/CIF',
    companyVat: 'NIF/CIF',
    vatPlaceholder: 'ESB12345678',
    sdiCode: 'Código SDI',
    companySdi: 'Código SDI',
    sdiPlaceholder: 'M5UXCR1',
    pec: 'Correo certificado (PEC)',
    companyPec: 'Correo certificado (PEC)',
    pecPlaceholder: 'empresa@pec.it',
    companyPhone: 'Teléfono de la empresa',
    companyPhonePlaceholder: '+34 900 123 456',
    officeAddress: 'Dirección de la oficina',
    street: 'Calle',
    streetPlaceholder: 'Calle Mayor 1',
    city: 'Ciudad',
    cityPlaceholder: 'Olbia',
    province: 'Provincia',
    provincePlaceholder: 'SS',
    postalCode: 'Código Postal',
    postalCodePlaceholder: '07026',
    presentation: 'Presentación',
    companyBioPlaceholder: 'Describe tu empresa a los clientes...',
    saveCompanyProfile: 'Guardar perfil de la empresa',
    companyProfileUpdated: 'Perfil de la empresa actualizado',
    perDay: '/día',
    saving: 'Guardando...',

    // Booking as guest
    bookingOptions: 'Opciones de Reserva',
    canBookAsGuest: 'También quiero reservar barcos',
    canBookAsGuestDesc: 'Activa esta opción para poder reservar barcos de otros vendors como cliente.',
    alsoClient: 'También cliente',

    // Extras Management
    tabExtras: 'Servicios Extra',
    extrasTitle: 'Mis Servicios Extra',
    extrasSubtitle: 'Gestiona los servicios adicionales para tus barcos',
    addExtra: 'Nuevo Extra',
    editExtra: 'Editar Extra',
    noExtras: 'No hay servicios extra',
    noExtrasHint: 'Crea tu primer servicio extra para ofrecerlo a los clientes',
    extraKey: 'Clave (ID único)',
    extraKeyPlaceholder: 'p. ej.: skipper_service',
    extraLabel: 'Nombre del Servicio',
    extraLabelPlaceholder: 'p. ej.: Servicio de Patrón',
    extraDescription: 'Descripción',
    extraDescPlaceholder: 'Describe el servicio extra...',
    extraPrice: 'Precio Predeterminado (€)',
    extraPriceType: 'Tipo de Precio',
    pricePerStay: 'Por alquiler',
    pricePerDay: 'Por día',
    pricePerPerson: 'Por persona',
    pricePerPersonDay: 'Por persona/día',
    extraStatusApproved: 'Aprobado',
    extraStatusPending: 'En revisión',
    extraStatusRejected: 'Rechazado',
    approvalWarning: 'Editar un extra aprobado lo reenviará para aprobación del administrador.',
    editResetsApproval: 'Editar un extra aprobado lo devuelve a revisión',
    extraCreated: 'Servicio extra creado. Pendiente de aprobación.',
    extraUpdated: 'Servicio extra actualizado',
    extraDeleted: 'Servicio extra eliminado',
    extraSaveError: 'Error al guardar el servicio extra',
    extraDeleteError: 'Error al eliminar el servicio extra',
    rejectionNotes: 'Notas de rechazo',
    loadExtrasError: 'Error al cargar los servicios extra',
  },

  // ============================================
  // COMPANY DASHBOARD
  // ============================================
  company: {
    // Menu groups
    menuMain: 'Principal',
    menuFleet: 'Gestión de Flota',
    menuOperations: 'Operaciones',
    menuFinance: 'Finanzas',
    menuSettings: 'Configuración',

    // Menu items
    overview: 'Resumen',
    fleet: 'Flota',
    calendar: 'Calendario',
    bookings: 'Reservas',
    clients: 'Clientes',
    coupons: 'Cupones',
    team: 'Equipo',
    earnings: 'Ganancias',
    reports: 'Informes',
    companyProfile: 'Perfil de la Empresa',
    settings: 'Configuración',
    companyAccount: 'Cuenta de la Empresa',

    // Overview
    welcomeBack: 'Bienvenido de nuevo, {name}',
    overviewSubtitle: 'Resumen de la actividad de tu empresa',
    recentBookings: 'Últimas Reservas',
    viewAll: 'Ver todas',
    quickActions: 'Acciones Rápidas',
    quickFleet: 'Gestionar Flota',
    quickFleetDesc: 'Añade y gestiona tus barcos',
    quickCalendar: 'Calendario',
    quickCalendarDesc: 'Consulta disponibilidad y reservas',
    quickReports: 'Informes',
    quickReportsDesc: 'Analiza ganancias y genera exportaciones',

    // Team
    teamSubtitle: 'Gestiona tu equipo operativo',
    teamComingSoon: 'Gestión de Equipo próximamente',
    teamComingSoonDesc: 'Pronto podrás añadir patrones, operadores y managers a tu equipo.',
    plannedRoles: 'Roles Previstos',
    roleSkipper: 'Patrón',
    roleSkipperDesc: 'Capitanes para tus barcos',
    roleOperator: 'Operador',
    roleOperatorDesc: 'Gestión de reservas y clientes',
    roleManager: 'Manager',
    roleManagerDesc: 'Supervisión de flota y operaciones',

    // Reports
    reportsSubtitle: 'Análisis detallado de ganancias',
    dateFrom: 'Desde',
    dateTo: 'Hasta',
    clearFilters: 'Restablecer',
    totalRevenue: 'Ingresos Totales',
    totalCommission: 'Comisiones',
    totalNet: 'Neto',
    noReportData: 'No hay datos para el periodo seleccionado',
    checkIn: 'Check-in',
    checkOut: 'Check-out',
    nights: 'Noches',

    // Export
    exportCSV: 'Exportar CSV',
    exportPDF: 'Exportar PDF',
    comingSoon: 'Próximamente',
  },

  // Promo overlay (public)
  promo: {
    close: 'Cerrar',
    discover: 'Descubrir',
    bookNow: 'Reservar Ahora',
    prev: 'Anterior',
    next: 'Siguiente',
  },

  // Service Provider System
  sp: {
    dashboardTitle: 'Mis Servicios',
    dashboardSubtitle: 'Gestiona tus solicitudes de servicio',
    role: 'Proveedor de Servicios',
    tabStats: 'Estadísticas',
    tabRequests: 'Solicitudes',
    tabProfile: 'Perfil',
    statsPending: 'Pendientes',
    statsAccepted: 'Aceptadas',
    statsCompleted: 'Completadas',
    statsRevenue: 'Ingresos Mensuales',
    statusPENDING: 'Pendiente',
    statusBROADCAST: 'En Difusión',
    statusACCEPTED: 'Aceptada',
    statusCOMPLETED: 'Completada',
    statusREJECTED: 'Rechazada',
    statusCANCELLED: 'Cancelada',
    statusEXPIRED: 'Caducada',
    noRequests: 'No hay solicitudes de servicio',
    requestDetail: 'Detalle de la Solicitud',
    boat: 'Barco',
    guest: 'Invitado',
    guestPhone: 'Teléfono del Invitado',
    passengers: 'Pasajeros',
    pickupDate: 'Fecha de Ida',
    returnDate: 'Fecha de Vuelta',
    pickup: 'Lugar de Recogida',
    dropoff: 'Destino',
    specialRequests: 'Solicitudes Especiales',
    rejectionReason: 'Motivo del Rechazo',
    rejectionReasonPlaceholder: 'Introduce el motivo del rechazo...',
    notes: 'Notas Internas',
    notesPlaceholder: 'Añade notas...',
    saveNotes: 'Guardar Notas',
    accept: 'Aceptar',
    reject: 'Rechazar',
    complete: 'Completar',
    confirmReject: 'Confirmar Rechazo',
    profileBasic: 'Información Básica',
    name: 'Nombre',
    phone: 'Teléfono',
    license: 'Número de Licencia',
    licensePlaceholder: 'P. ej. OT/12345',
    bio: 'Descripción',
    fleet: 'Flota de Vehículos',
    fleetSize: 'Número de Vehículos',
    maxPassengers: 'Máx. Pasajeros',
    vehicleTypes: 'Tipos de Vehículo',
    vehiclePlaceholder: 'P. ej. Sedán, Furgoneta de 8 plazas',
    serviceArea: 'Zonas de Servicio',
    serviceAreaPlaceholder: 'P. ej. Olbia, Porto Cervo',
    operatingHours: 'Horario de Servicio',
    saveProfile: 'Guardar Perfil',
    // Calendar tab
    tabCalendar: 'Calendario',
    calendarTitle: 'Calendario de Citas',
    calendarRequests: 'solicitudes',
    // Extras tab
    tabExtras: 'Servicios',
    myExtras: 'Mis Servicios',
    createExtra: 'Nuevo Servicio',
    editExtra: 'Editar Servicio',
    extrasEmpty: 'No se ha creado ningún servicio',
    extraPendingInfo: 'Los nuevos servicios se envían para aprobación. Editar un servicio aprobado lo devuelve a revisión.',
    extraEditWarning: 'Al editar un servicio aprobado, volverá al estado "En revisión" para una nueva aprobación.',
    extraDeleteConfirm: '¿Seguro que quieres eliminar',
    extraApproved: 'Aprobado',
    extraPendingReview: 'En revisión',
    extraRejected: 'Rechazado',
    extraKeyLabel: 'Clave (ID único)',
    extraNameLabel: 'Nombre del Servicio',
    extraDescLabel: 'Descripción',
    extraPriceLabel: 'Precio Predeterminado (€)',
    extraPriceTypeLabel: 'Tipo de Precio',
    extraSave: 'Guardar Cambios',
    extraCategory: 'Categoría',
    extraCategoryMobility: 'Movilidad (alquileres y traslados)',
    extraCategoryOther: 'Otro servicio',
    extraPorts: 'Puertos operativos *',
    extraPortsHint: 'Selecciona los puertos donde ofreces este servicio. Los clientes solo verán el servicio para los barcos amarrados en estos puertos.',
    extraPortsEmpty: 'No hay puertos disponibles',
    extraPortsRequired: 'Selecciona al menos un puerto operativo',
    extraPortsSelectedOne: 'puerto seleccionado',
    extraPortsSelectedMany: 'puertos seleccionados',
    extraOperatingAt: 'Operativo en',
    pricingMode: 'Modalidad de precio',
    pricingModeFixed: 'Precio fijo',
    pricingModeQuote: 'Bajo petición (presupuesto)',
    pricingModeQuoteHint: 'El cliente solicitará un presupuesto en lugar de ver el precio. Lo recibirás en tu panel como una solicitud a gestionar.',
    priceNotApplicable: 'No aplicable',
    // Marketplace broadcast (Phase 1)
    broadcastTitle: 'Marketplace en directo',
    broadcastHint: 'El primero que acepta se lleva el servicio. ¡Sé rápido!',
    claimNow: 'Aceptar ya',
    claimSuccess: '¡Solicitud aceptada!',
    claimLost: 'Ya la ha tomado otro proveedor',
    // Empty state — new SP with no linked ServiceProvider profile yet
    noProfileYet: 'Todavía no tienes un perfil de proveedor activo',
    noProfileHint: 'Espera a que el administrador te asigne un servicio, o suscríbete a una plantilla de servicio desde la pestaña "Mis ofertas" para empezar a recibir solicitudes del marketplace.',
    pendingApprovalTitle: 'Cuenta Pendiente de Aprobación',
    pendingApprovalMessage: 'Tu cuenta está siendo revisada. Se te notificará cuando sea aprobada.',
    // Generic service keys
    serviceType: 'Tipo de Servicio',
    bikeRental: 'Alquiler de Bicicletas',
    ebikeRental: 'Alquiler de E-Bike',
    scooterRental: 'Alquiler de Scooter',
    monopattinoRental: 'Alquiler de Patinete',
    transferPorto: 'Traslado al Puerto',
    allServices: 'Todos los Servicios',
    filterByService: 'Filtrar por servicio',
    requestFrom: 'Solicitud de',
    quantity: 'Cantidad',
    serviceDate: 'Fecha del Servicio',
    providerNotes: 'Notas del Proveedor',
    // Error / toast messages
    errLoadRequests: 'No se han podido cargar las solicitudes de servicio',
    errLoadStats: 'No se han podido cargar las estadísticas',
    errLoadCalendar: 'No se ha podido cargar el calendario',
    errLoadProfile: 'No se ha podido cargar el perfil',
    errSaveProfile: 'No se ha podido guardar el perfil',
    errAcceptRequest: 'No se ha podido aceptar la solicitud',
    errRejectRequest: 'No se ha podido rechazar la solicitud',
    errCompleteRequest: 'No se ha podido completar la solicitud',
    errSaveNotes: 'No se han podido guardar las notas',
    profileSaved: 'Perfil guardado correctamente',
    notesSaved: 'Notas guardadas',
    capacityCheck: 'Capacidad automática',
    capacityCheckEnabled: 'Bloqueo automático activo',
    capacityCheckDisabled: 'Bloqueo automático desactivado',
    capacityCheckHintEnabled: 'Cuando está activo, el sistema rechaza automáticamente las nuevas solicitudes si ya has alcanzado la capacidad máxima configurada para esa fecha.',
    capacityCheckHintDisabled: 'Recibirás todas las solicitudes incluso por encima de la capacidad configurada y gestionarás manualmente los posibles conflictos.',
    capacityCheckSaved: 'Configuración de capacidad actualizada',
    capacityExhausted: 'El proveedor no tiene disponibilidad para la fecha solicitada',
    // Payment collection mode
    paymentMode: 'Modalidad de cobro',
    paymentModeFull: 'La plataforma cobra todo',
    paymentModeFullDesc: 'La plataforma cobra el importe total de la reserva y te abona el neto mediante transferencia bancaria.',
    paymentModeCommissionOnly: 'La plataforma cobra solo la comisión',
    paymentModeCommissionDesc: 'La plataforma retiene solo su porcentaje. El saldo restante te lo paga directamente el cliente en el check-in (efectivo o TPV).',
    paymentModeFullHint: 'Modalidad estándar: todo pasa por la plataforma y recibes el neto por transferencia.',
    paymentModeCommissionHint: 'En esta modalidad los clientes te pagarán el saldo directamente en el puerto. La plataforma retiene solo su porcentaje.',
    spIban: 'IBAN para pagos',
    spIbanHolder: 'Titular de la cuenta',
    paymentModeSaved: 'Modalidad de cobro guardada',
    // SP catalog (offers tab)
    tabOffers: 'Mis ofertas',
    offersTitle: 'Catálogo de Ofertas',
    offersDesc: 'Suscríbete a las plantillas de servicio creadas por el administrador con tus propias tarifas',
    offersAdd: 'Añadir oferta',
    offersEdit: 'Editar oferta',
    offersDelete: 'Eliminar oferta',
    offersSelectTemplate: 'Seleccionar plantilla',
    offersCustomPrice: 'Precio personalizado',
    offersCapacity: 'Capacidad',
    offersNotes: 'Notas',
    offersPorts: 'Puertos operativos',
    offersEmpty: 'No hay ofertas activas. Añade una para empezar.',
    offersNoTemplates: 'No hay plantillas disponibles. El administrador debe crear al menos una.',
    offersCreated: 'Oferta creada',
    offersUpdated: 'Oferta actualizada',
    offersDeleted: 'Oferta eliminada',
  },

  // ============================================
  // SERVICES SUBDOMAIN
  // ============================================
  servicesLogin: {
    title: 'Insula Services',
    subtitle: 'Área de Proveedores de Servicios',
    sectionLabel: 'Acceso Proveedores',
    submit: 'Iniciar sesión',
    submitting: 'Iniciando sesión...',
    accessDenied: 'Esta área está reservada para proveedores de servicios.',
    copyright: 'Todos los derechos reservados.',
  },
  servicesCatalog: {
    title: 'Servicios Disponibles',
    subtitle: 'Nuestros partners de servicios locales',
    noProviders: 'No hay proveedores disponibles en este momento',
    becomeProvider: 'Conviértete en Proveedor',
    requestService: 'Solicitar un Servicio',
    serviceArea: 'Zonas de Servicio',
    vehicleTypes: 'Vehículos',
    maxPassengers: 'Máx. Pasajeros',
    howItWorks: 'Cómo Funciona',
    howItWorksDesc: 'Reserva una excursión en barco y añade el servicio de traslado. Un proveedor local se encargará de tu transporte.',
  },
  servicesNavbar: {
    dashboard: 'Panel',
    catalog: 'Catálogo de Servicios',
    login: 'Iniciar sesión',
    logout: 'Cerrar sesión',
  },

  // ============================================
  // SP SELF-REGISTRATION WIZARD
  // ============================================
  spReg: {
    title: 'Conviértete en Proveedor de Servicios',
    subtitle: 'Únete a la plataforma Insula Services en pocos pasos.',
    becomeProvider: 'Conviértete en Proveedor',
    step1Title: 'Cuenta',
    step2Title: 'Datos de la empresa',
    step3Title: 'Categorías y puertos',
    step4Title: 'Resumen',
    next: 'Siguiente',
    previous: 'Atrás',
    submit: 'Enviar solicitud',
    fieldName: 'Nombre y apellidos',
    fieldEmail: 'Email',
    fieldPassword: 'Contraseña',
    fieldPasswordConfirm: 'Confirmar contraseña',
    fieldPhonePrefix: 'Prefijo',
    fieldPhoneNumber: 'Teléfono',
    fieldCompanyName: 'Razón social',
    fieldVAT: 'NIF/CIF',
    fieldTaxCode: 'Código fiscal',
    fieldAddress: 'Dirección',
    fieldCity: 'Ciudad',
    fieldProvince: 'Provincia',
    fieldPostalCode: 'Código postal',
    selectCategories: 'Categorías de servicios ofrecidos',
    selectPorts: 'Puertos operativos',
    summaryTitle: 'Revisa tus datos',
    summaryHint: 'Asegúrate de que todo sea correcto antes de enviar tu solicitud de registro.',
    successTitle: 'Solicitud enviada',
    successMessage: 'Tu registro se ha recibido. Un administrador lo revisará en breve y recibirás una notificación por email.',
    errors: {
      required: 'Este campo es obligatorio',
      emailInvalid: 'Email no válido',
      passwordWeak: 'La contraseña debe tener al menos 8 caracteres',
      passwordMismatch: 'Las contraseñas no coinciden',
      selectCategory: 'Selecciona al menos una categoría',
      selectPort: 'Selecciona al menos un puerto',
      emailExists: 'Este email ya está registrado',
      generic: 'Se ha producido un error. Inténtalo de nuevo.',
    },
  },

  boatWizard: {
    useType: {
      label: 'Uso previsto',
      locazione: { label: 'Alquiler bareboat', desc: 'Alquiler sin patrón (bareboat): aparece en el catálogo de alquiler' },
      excursionOnly: { label: 'Solo excursiones', desc: 'Se usa solo para excursiones/experiencias, excluida del catálogo de alquiler' },
    },
    pricingMode: {
      label: 'Modalidad de precio',
      fixed: { label: 'Precio fijo', desc: 'Precios visibles: los clientes ven los precios y pueden reservar directamente' },
      quoteOnRequest: { label: 'Presupuesto bajo petición', desc: 'Los clientes envían una solicitud de presupuesto; tú respondes con un precio personalizado' },
      priceFieldsHidden: 'Los campos de precio están ocultos porque el barco está configurado como "Presupuesto bajo petición".',
    },
  },

};

export default es;

